function matchesMediaQuery(breakpointName) {
  if (!window.themeVariables.mediaQueries.hasOwnProperty(breakpointName)) {
    throw `Media query ${breakpointName} does not exist`;
  }
  return window.matchMedia(window.themeVariables.mediaQueries[breakpointName]).matches;
}
function mediaQueryListener(breakpointName, func) {
  if (!window.themeVariables.mediaQueries.hasOwnProperty(breakpointName)) {
    throw `Media query ${breakpointName} does not exist`;
  }
  return window.matchMedia(window.themeVariables.mediaQueries[breakpointName]).addEventListener("change", func);
}
function ValidateEmail(inputText) {
  var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
  if (inputText.value.match(mailformat)) {
    return true;
  } else {
    return false;
  }
}

class SizeConverterComponent extends HTMLElement {
  constructor() {
    super();
    this.handleGenderChange = this.handleGenderChange.bind(this);
    this.handleVariantChange = this.handleVariantChange.bind(this);
    this.linkedColors = document.querySelectorAll('.thumbnail-swatch');
  }

  connectedCallback() {
    // set default to us if there is privacy issues with localization
    this.currentMarket = window.localization?.size_market || 'default_size';
    document.addEventListener("gender:change", this.handleGenderChange);
    document.addEventListener("variant:change", this.handleVariantChange);
    this.initializeSizeSwitching();
  }

  disconnectedCallback() {
    document.removeEventListener("gender:change", this.handleGenderChange);
    document.removeEventListener("variant:change", this.handleVariantChange);
  }

  handleGenderChange(event) {
    this.setAttribute('data-type', event.detail.swatch.innerText.toLowerCase());
    // Only clear active filters when the customer actually toggled gender - checkPreset()
    // replays this same click (untrusted) on load/refresh just to restore UI state from the
    // ?sizesfor= URL param, and must not wipe out the filters that URL is being loaded with.
    if (event.detail.isUserInitiated && document.querySelector('.facets-clear-all')) {
      document.querySelector('.facets-clear-all').click();
    }
    if (!this.closest('facets-form')) {
      document.querySelector('product-gallery').setAttribute('data-type', event.detail.swatch.innerText.toLowerCase());
    }
    this.showSize(this.currentMarket);
    this.updateSelectedSizeLabel();
  }

  // Mirrors the currently-checked size swatch's text (which showSize() keeps correct for the
  // active gender + market) into the "Add to cart - market size" label. Needed because the
  // US size differs by gender, and a gender toggle does not re-render the buy button server-side.
  updateSelectedSizeLabel() {
    const formId = this.getAttribute('form-id');
    const form = formId ? document.forms[formId] : null;
    if (!form) return;

    // Stay consistent with the Liquid rule: only show a size on a purchasable variant.
    const submitButton = form.querySelector('button[type="submit"]');
    const purchasable = submitButton && !submitButton.disabled;

    const marketSpan = this.querySelector('.nav--sizes.active') || this.querySelector('.nav--sizes');
    const market = marketSpan ? marketSpan.textContent.trim() : '';

    // Find the checked size input for THIS form (document-scoped via the form attribute), then read
    // its associated swatch label text.
    const checkedInput = document.querySelector(`input.input-swatch-size[form="${formId}"]:checked`);
    let sizeText = '';
    if (checkedInput) {
      const label = document.querySelector(`label[for="${CSS.escape(checkedInput.id)}"]`) || checkedInput.nextElementSibling;
      const label_size = label.querySelector('.swatch-size-value') || label.querySelector('span');
      sizeText = label_size ? label_size.textContent.trim() : '';
    }

    const labelText = (purchasable && market && sizeText) ? `${market} ${sizeText}` : '';
    form.querySelectorAll('[data-selected-size]').forEach((span) => {
      span.textContent = labelText ? ` - ${labelText}` : '';
    });
  }

  handleVariantChange(event) {
    this.showSize(this.currentMarket);
    this.updateSelectedSizeLabel();
  }

  initializeSizeSwitching() {
    this.showSize(window.localization?.size_market || 'default_size');
    this.updateSelectedSizeLabel();
    // On the product page the swatches live in a sibling `.variant-picker__option-values` div
    // rather than inside size-converter itself (which there only wraps the market label), so
    // the "ready" flag needs to go on the shared fieldset instead for the fade-in CSS to reach them.
    (this.closest('.variant-picker__option') || this).setAttribute('data-ready', '');
  }

  showSize(selectedSize) {
    let sizes_swatch;
    if (!this.closest('facets-form')) {
      sizes_swatch = (this.closest('variant-picker') || document).querySelectorAll('.block-swatch-size');
    } else {
      sizes_swatch = document.querySelectorAll('.block-swatch-size');
    }
    if (!sizes_swatch) return;
    sizes_swatch.forEach((swatch) => {
      if (swatch.hasAttribute('data-original')) {
        const currentSize = swatch.getAttribute('data-original');
        const replaceSize = currentSize.split('/');
        let sizeText = null;
        let display = 'none';

        if (replaceSize) {
          if (selectedSize === 'US') {
            if (this.getAttribute('data-type') === 'mens' && replaceSize.length >= 3 && replaceSize[0].includes('Mens')) {
              sizeText = replaceSize[0].split(' ')[2];
              display = 'flex';
            } else if (this.getAttribute('data-type') === 'womens' && replaceSize.length >= 3 && replaceSize[0].includes('Womens')) {
              sizeText = replaceSize[0].split(' ')[2];
              display = 'flex';
            } else if (replaceSize.length === 4) {
              if (this.getAttribute('data-type') === 'womens') {
                sizeText = replaceSize[1].split(' ')[3];
              } else {
                sizeText = replaceSize[0].split(' ')[2];
              }
              display = 'flex';
            }
          } else if (selectedSize === 'UK' || selectedSize === 'EU') {
            const isMens = this.getAttribute('data-type') === 'mens';
            const isWomens = this.getAttribute('data-type') === 'womens';
            const lastIndex = replaceSize.length - 1;
            const secondLastIndex = replaceSize.length - 2;

            let targetIndex = selectedSize === 'UK' ? secondLastIndex : lastIndex;

            if (isMens && replaceSize.length >= 3 && replaceSize[0].includes('Mens')) {
              sizeText = replaceSize[targetIndex].split(' ')[2];
              display = 'flex';
            } else if (isWomens && replaceSize.length >= 3 && replaceSize[0].includes('Womens')) {
              sizeText = replaceSize[targetIndex].split(' ')[2];
              display = 'flex';
            } else if (replaceSize.length === 4) {
              sizeText = replaceSize[targetIndex].split(' ')[2];
              display = 'flex';
            }
          }
        }

        swatch.style.display = display;
        if (swatch.previousElementSibling && swatch.previousElementSibling.checked && display === 'none') {
          const form = document.forms[this.getAttribute("form-id")];
          if (form) {
            const submitButton = form.querySelector('button[type="submit"]');
            if (submitButton) {
              // need to disable the selected variant in shopify's variant picker if the size is not available to prevent customers from adding the wrong variant to cart
                // Reset the variant id input and clean URL
                const idInput = form.querySelector('input[name="id"]');
                if (idInput) {
                idInput.value = '';
                }
                const url = new URL(window.location.href);
                if (url.searchParams.has('variant')) {
                url.searchParams.delete('variant');
                window.history.replaceState({}, '', url.toString());
                }
              submitButton.disabled = true;
              submitButton.innerText = 'Select size';
              swatch.previousElementSibling.checked = false;
            }
          }
        }
        if (sizeText) {
          // Only update the size-value span so any extra info span(s) in the label are preserved.
          // Falls back to textContent for legacy markup without the dedicated span.
          const sizeValueSpan = swatch.querySelector('.swatch-size-value') || swatch.querySelector('span');
          if (sizeValueSpan) {
            sizeValueSpan.textContent = sizeText;
          } else {
            swatch.textContent = sizeText;
          }
        }
      }
    });
  }
}

// Register the custom element with the browser.
customElements.define('size-converter', SizeConverterComponent);

class GenderSwatch extends HTMLElement {
  constructor() {
    super();
    this.updateHistoryState = this.updateHistoryState.bind(this);
  }
  connectedCallback() {
    this.querySelectorAll('.button').forEach(swatch => {
      swatch.addEventListener('click', (event) => {
        // Remove 'is-active' class from all buttons
        this.querySelectorAll('.button').forEach(button => {
          button.classList.add('button--outline');
        });
        if (this.closest('quick-buy-modal')) {
          const modal = this.closest('quick-buy-modal');
          const gender = swatch.textContent.trim().toLowerCase();
          modal.setAttribute('data-quick-buy-gender', gender);
          const converter = this.closest('variant-picker')?.querySelector('size-converter');
          this.querySelectorAll('.button').forEach(button => button.classList.add('button--outline'));
          swatch.classList.remove('button--outline');
          if (converter) {
            converter.setAttribute('data-type', gender);
            converter.showSize?.(converter.currentMarket);
            converter.updateSelectedSizeLabel?.();
          }
          modal.querySelector('product-gallery')?.setAttribute('data-type', gender);
          modal.querySelector('.product-title')?.setAttribute('data-gender', gender);
          return;
        }
        this.updateHistoryState(event.target);
        // Add 'is-active' class to the clicked button
        swatch.classList.remove('button--outline');
        this.updateGenderLabel(swatch.textContent.trim().toLowerCase());
        // Dispatch custom event
        document.dispatchEvent(new CustomEvent("gender:change", { detail: { swatch, isUserInitiated: event.isTrusted } }));
      });
    });

    this.checkPreset();
  }
  disconnectedCallback() {
    this.querySelectorAll('.button').forEach(swatch => {
      swatch.removeEventListener('click', this.handleClick);
    });
  }
  // Drives the "Men's "/"Women's " [data-gender-label] spans in the product title
  // (shown/hidden by theme.css via .product-title[data-gender=...]). Lives here rather
  // than in size-converter because size-converter only renders for footwear, while the
  // gender switcher exists on any product with the target-gender metafield.
  updateGenderLabel(gender) {
    document.querySelector('.product-info .product-title')?.setAttribute('data-gender', gender);
  }

  updateHistoryState(event) {
    let gender = event.textContent.toLowerCase();
    const url = new URL(window.location.href);
    url.searchParams.set('sizesfor', gender);
    let newUrl = url.toString();
    if (event) {
      let gender = event.textContent.toLowerCase();
      const url = new URL(window.location.href);
      url.searchParams.set('sizesfor', gender);
      let newUrl = url.toString();
      window.history.replaceState({
        path: newUrl
      }, '', newUrl);
       document.querySelectorAll('a.thumbnail-swatch').forEach(link => {
        const url = new URL(link.href);
        if (gender) {
          url.searchParams.set('sizesfor', gender);
        } else {
          url.searchParams.delete('sizesfor');
        }
        link.href = url.toString();
      });
      document.querySelectorAll('product-card a').forEach(link => {
        const url = new URL(link.href);
        if (gender) {
          url.searchParams.set('sizesfor', gender);
        } else {
          url.searchParams.delete('sizesfor');
        }
        link.href = url.toString();
      });
    } else if (window.location.search.includes('sizesfor')) {
      let searchParams = new URLSearchParams(window.location.search);
      let gender = searchParams.get('sizesfor');
      let newUrl = "".concat(window.location.protocol, "//").concat(window.location.host).concat(window.location.pathname, "?gender=").concat(gender);
      window.history.replaceState({
        path: newUrl
      }, '', newUrl);
    }
  }

  checkPreset() {
    const modal = this.closest('quick-buy-modal');
    if (modal) {
      const gender = modal.getAttribute('data-quick-buy-gender') || new URLSearchParams(window.location.search).get('sizesfor') || modal.getAttribute('data-preselect');
      const swatches = [...this.querySelectorAll('.button')];
      const target = swatches.find(swatch => swatch.textContent.trim().toLowerCase() === gender) || swatches[0];
      target?.click();
      return;
    }
    var urlParam = window.location.search;
    let searchParams = new URLSearchParams(urlParam);
    if (searchParams.has('sizesfor') === true) {
      var search = searchParams.get('sizesfor');
      document.querySelectorAll('size-converter').forEach(element => {
        element.setAttribute('data-type', search);
      });
      if (!this.closest('facets-form')) {
        document.querySelector('product-gallery').setAttribute('data-type', search);
      }
      this.updateGenderLabel(search);
      this.querySelectorAll('.button').forEach(swatch => {
        if (swatch.textContent.toLowerCase() == search) {
          // Dispatch a click event
          swatch.dispatchEvent(new MouseEvent('click', {
            bubbles: true,
            cancelable: true,
            view: window
          }));
        }
      });
    } else {
      if (this.closest('.quick-buy-modal')) {
        var search = this.closest('.quick-buy-modal').getAttribute('data-preselect');
        this.closest('variant-picker').querySelector('size-converter').setAttribute('data-type', search);
        this.querySelectorAll('.button').forEach(swatch => {
          if (swatch.textContent.toLowerCase() == search) {
            // Dispatch a click event
            swatch.dispatchEvent(new MouseEvent('click', {
              bubbles: true,
              cancelable: true,
              view: window
            }));
          }
        });
      }
    }
  }
}

customElements.define('gender-size-switcher', GenderSwatch);



import { CountdownTimer } from 'theme';
class CountdownTimerSession extends CountdownTimer {
  constructor() {
    super();
  }

  // New method to update button text based on a new attribute
  recalculateFlips_fn = function () {
    const dateNow = /* @__PURE__ */ new Date();
    if (_expirationDate < dateNow) {
      if (this.getAttribute("expiration-behavior") === "hide") {
        this.closest(".shopify-section").remove();
      } else {
      }
    }
  };

}
if (!window.customElements.get("countdown-timer-session")) {
  window.customElements.define("countdown-timer-session", CountdownTimerSession);
}

document.addEventListener('product:rerender', function () {
  if (document.querySelector('notify-preorder')) {
    document.querySelectorAll('notify-preorder').forEach(element => {
      customElements.whenDefined('notify-preorder').then(() => {
        element.connectedCallback();
      });
    });
  }
});

class NotifyPreorder extends HTMLElement {
  constructor() {
    super();
    this.backInStock = this.backInStock.bind(this);
    this.handleEmailKeydown = this.handleEmailKeydown.bind(this);
    this.variantId = null;
    this.variantTitle = null;
    this.noteTemplate = null;
    this._onVariantChange = null;
  }

  connectedCallback() {
    this.loadUserSize();

    const message = this.querySelector('.BackInStock__message');
    // Keep the server-rendered note ("We will email you the moment X is back in stock"), since the
    // same element is reused for the error/subscribed states and has to be restorable afterwards.
    if (message && this.noteTemplate == null) {
      this.noteTemplate = message.innerHTML;
    }

    const notifyBackButton = this.querySelector('.notify-back');
    if (notifyBackButton) {
      notifyBackButton.addEventListener('click', this.backInStock);
    }

    const emailInput = this.querySelector('.BackInStock .input');
    if (emailInput) {
      emailInput.addEventListener('keydown', this.handleEmailKeydown);
    }

    this._onVariantChange = (event) => {
      this.handleVariantChange(event);
      this.updatePreorderState(event.detail.variant);
    };
    document.addEventListener('variant:change', this._onVariantChange);
  }

  disconnectedCallback() {
    if (this._onVariantChange) {
      document.removeEventListener('variant:change', this._onVariantChange);
      this._onVariantChange = null;
    }
  }

  // The field sits outside the product form, so Enter would otherwise do nothing.
  handleEmailKeydown(event) {
    if (event.key !== 'Enter') return;
    event.preventDefault();
    this.backInStock();
  }

  handleQuickBuyVariantChange(event) {
    this.updatePropertiesFromEvent(event);
    this.updatePreorderState(event.detail.variant);
  }

  handleVariantChange(event) {
    this.updatePropertiesFromEvent(event);
    const backInStockElement = this.querySelector('.BackInStock');
    if (!backInStockElement) return;

    const available = event.detail.variant.available;
    backInStockElement.classList.toggle('hidden', available);

    const notifyBackButton = this.querySelector('.notify-back');
    if (notifyBackButton) {
      notifyBackButton.removeEventListener('click', this.backInStock);
      notifyBackButton.textContent = window.themeVariables.strings.notifyMeButton;
      if (!available) {
        notifyBackButton.addEventListener('click', this.backInStock);
      }
    }

    this.resetNote(event.detail.variant.title);
  }

  // Restores the note to its default wording and points it at the newly selected variant,
  // clearing any error/subscribed state left over from a previous selection.
  resetNote(variantTitle) {
    const message = this.querySelector('.BackInStock__message');
    if (!message || this.noteTemplate == null) return;

    message.classList.remove('alert', 'subscribed');
    message.innerHTML = this.noteTemplate;

    const variantEl = message.querySelector('[data-variant-title]');
    if (variantEl && variantTitle) variantEl.textContent = variantTitle;
  }

  loadUserSize() {
    const size = sessionStorage.getItem('userShoeSize');
    if (!size) return;
    const variantPicker = document.querySelector('variant-picker');
    if (!variantPicker) return;
    const variantInput = variantPicker.querySelector(`input[value="${size}"]`);
    if (variantInput) {
      setTimeout(() => variantInput.parentNode.querySelector('label').click(), 500);
    }
  }

  saveUserSize(event) {
    sessionStorage.setItem('userShoeSize', event.detail.variant.option1);
  }

  updatePropertiesFromEvent(event) {
    if (event.detail.variant) {
      this.variantTitle = event.detail.variant.name;
      this.variantId = event.detail.variant.id;
    }
  }

  updatePropertiesFromJson(jsonData) {
    this.variantTitle = jsonData.selected_variant.name;
    this.variantId = jsonData.selected_variant.id;
  }

  updatePreorderState(newVariant) {
    if (!newVariant) return;

    const $preorderMessage = document.getElementById('preOrderMessage');
    let $preorderLineMessage = document.getElementById('PreOrderLine');
    const $addToCartButton = this.querySelector('button[type="submit"]');

    const matchingEl = Array.from(this.querySelectorAll('.js-preorder-variant'))
      .find(el => el.getAttribute('data-variantid') == newVariant.id);

    const isAvailable = matchingEl?.dataset.available === 'true';
    const deliveryMessage = matchingEl?.dataset.deliverymessage;
    const hasMessage = deliveryMessage && deliveryMessage !== '' && deliveryMessage !== "''";

    const clearPreorder = () => {
      $preorderMessage.innerHTML = null;
      if ($preorderLineMessage) {
        $preorderLineMessage.value = null;
        $preorderLineMessage.remove();
        $preorderLineMessage = null;
      }
    };

    // Preserve the server-rendered selected-size label (e.g. " - UK 9") that Liquid put inside
    // the button, since we're about to replace the button's innerHTML.
    const selectedSize = $addToCartButton?.querySelector('[data-selected-size]')?.textContent || '';
    const addToCartLabel = `${window.themeVariables.strings.addToCartButton} <span data-selected-size>${selectedSize}</span>`;

    if (isAvailable && hasMessage) {
      $preorderMessage.innerHTML = `${window.themeVariables.strings.preOrderLabel}: ${deliveryMessage}`;
      $addToCartButton.innerHTML = addToCartLabel;
      if (!$preorderLineMessage) {
        $preorderLineMessage = document.createElement('input');
        $preorderLineMessage.type = 'hidden';
        $preorderLineMessage.id = 'PreOrderLine';
        $preorderLineMessage.name = `properties[${window.themeVariables.strings.preOrderLabel}]`;
        this.appendChild($preorderLineMessage);
      }
      $preorderLineMessage.value = deliveryMessage.split('Full')[0];
    } else {
      clearPreorder();
      $addToCartButton.innerHTML = newVariant.available
        ? addToCartLabel
        : `${window.themeVariables.strings.soldOutButton} <span data-selected-size></span>`;
    }

    // The section re-render doesn't replace this button, and sized products render it disabled
    // ("Select size") until a size is picked, so its state has to follow the variant here.
    $addToCartButton.disabled = !newVariant.available;

    // size-converter may have run its variant:change handler while the button was still disabled,
    // which leaves the " - EU 38" size suffix empty
    // getAttribute, as form.id is shadowed by the form's input
    const formId = this.closest('form')?.getAttribute('id');
    document.querySelector(`size-converter[form-id="${formId}"]`)?.updateSelectedSizeLabel();
  }

  backInStock() {
    const userEmail = this.querySelector('.BackInStock .input');
    const label = this.querySelector('.BackInStock__message');
    if (userEmail?.value && ValidateEmail(userEmail)) {
      this.subscribeUser(userEmail, label);
    } else {
      this.updateUIForInvalidEmail(label);
    }
  }

  subscribeUser(userEmail, label) {
    if (!this.variantId) {
      const buyButtons = this.querySelector('buy-buttons');
      this.variantId = buyButtons.getAttribute('data-variant-id');
      this.variantTitle = buyButtons.getAttribute('data-variant-title');
    }

    fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=UtcaRi', {
      method: 'POST',
      headers: {
        accept: 'application/json',
        revision: '2025-10-15',
        'content-type': 'application/json'
      },
      body: JSON.stringify({
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            profile: { data: { type: 'profile', attributes: { email: userEmail.value } } },
            channels: ['EMAIL']
          },
          relationships: {
            variant: { data: { type: 'catalog-variant', id: `$shopify:::$default:::${this.variantId}` } }
          }
        }
      })
    })
      .then(response => {
        if (response.status === 202) this.updateUIForSuccess(label, userEmail);
      })
      .catch(() => this.updateUIForNetworkError(label));
  }

  updateUIForSuccess(label, userEmail) {
    label.classList.remove('alert');
    label.classList.add('subscribed');
    userEmail.classList.add('subscribed');
    label.textContent = `Subscribed: ${this.variantTitle}`;
    this.querySelector('.notify-back').textContent = 'Subscribed';
  }

  updateUIForInvalidEmail(label) {
    label.classList.add('alert');
    label.classList.remove('subscribed');
    label.textContent = 'Please enter a valid email';
  }

  updateUIForNetworkError(label) {
    label.classList.add('alert');
    label.textContent = 'Network error, try again later';
  }

}
if (!window.customElements.get("notify-preorder")) {
  window.customElements.define("notify-preorder", NotifyPreorder);
}

import { Drawer } from 'theme';

var RedirectPopup = class extends Drawer {
  async connectedCallback() {
    super.connectedCallback();
    if (sessionStorage.getItem("popupClosedForSession") === "true") return;

    await this.detectCountry(); // Wait for detectCountry to complete

    if (this.properStore) {
      this.showTimeout = setTimeout(() => this.show(), this.apparitionDelay);
    }

    this.removeEventListener('dialog:before-hide', this.handleClose); // Remove any existing listener
    this.addEventListener('dialog:before-hide', () => this.handleClose());
  }

  async detectCountry() {
    if (this.properStore) return;
    try {
      const response = await fetch('https://' + window.location.hostname + '/browsing_context_suggestions.json');
      if (!response.ok) {
        throw new Error('Network response was not ok ' + response.statusText);
      }
      this.data = await response.json();

      const redirectData = JSON.parse(document.querySelector('[data-redirects]').innerHTML);
      const redirect_list = redirectData.redirects;

      for (let redirect in redirect_list) {
        if (redirect_list.hasOwnProperty(redirect)) {
          const country_list = redirect_list[redirect].split(',');
          if (country_list.includes(this.data.detected_values.country.handle)) {
            this.properStore = true;

            const element = this.querySelector('.redirect_button .button');
            const redirect_flag = this.querySelector('.redirect_button a');
            const content = this.querySelector('.prose');
            const flagImage = this.querySelector('.redirect_button img');

            if (element) {
              element.innerHTML = element.textContent.replace('{country}', this.data.detected_values.country.handle);
              content.innerHTML = content.textContent.replace('{country}', this.data.detected_values.country_name);
              redirect_flag.href = redirect + window.location.pathname + window.location.search;
              element.href = redirect + window.location.pathname + window.location.search;
            }
            if (flagImage) {
              const countryCode = this.data.detected_values.country.handle.toLowerCase();
              flagImage.src = `//cdn.shopify.com/static/images/flags/${countryCode}.svg?format=jpg&width=200`;
              flagImage.srcset = `//cdn.shopify.com/static/images/flags/${countryCode}.svg?format=jpg&width=200`;
              flagImage.alt = `${this.data.detected_values.country_name} Flag`;
            }
            return;  // Stop further processing once a match is found
          } else {
            this.properStore = false;
          }
        }
      }
    } catch (error) {
      console.error('There has been a problem with your fetch operation:', error);
    }
  }

  get apparitionDelay() {
    return parseInt(this.getAttribute("apparition-delay") || 0) * 1e3;
  }

  handleClose() {
    sessionStorage.setItem("popupClosedForSession", "true");
    if (this.showTimeout) {
      clearTimeout(this.showTimeout); // Prevent delayed show
      this.showTimeout = null;
    }
  }

  attributeChangedCallback(name, oldValue, newValue) {
    super.attributeChangedCallback(name, oldValue, newValue);
    if (name === "open" && this.open) {
      localStorage.setItem("theme:redirect-popup-appeared", "true");
    }
  }
};

if (!window.customElements.get("redirect-popup")) {
  window.customElements.define("redirect-popup", RedirectPopup);
}




// js/common/facets/facets-sort-popover.js
var FacetsSortInline = class extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.querySelectorAll('input').forEach(sort_input => {
      sort_input.addEventListener('change', (event) => {
        this.onSortChanged(event);
      });
    });
  }
  onSortChanged(event) {
    const url = new URL(window.location.href);
    url.searchParams.set("sort_by", event.target.value);
    url.searchParams.delete("page");
    url.searchParams.set("section_id", this.getAttribute("section-id"));
    this.dispatchEvent(new CustomEvent("facet:update", {
      bubbles: true,
      detail: {
        url
      }
    }));
  }
};
if (!window.customElements.get("facets-sort-inline")) {
  window.customElements.define("facets-sort-inline", FacetsSortInline);
}



document.addEventListener('dialog:before-show', function () {
  var availabilityElement = document.querySelector('#facets-sidebar-filter\\.v\\.availability');
  if (availabilityElement) {
    availabilityElement.click();
  }
});



/**
 * Cart Discount Component for Prestige Theme
 * Handles applying and removing discount codes in the cart.
 */
class CartDiscountComponent extends HTMLElement {
  constructor() {
    super();
    this.applyDiscount = this.applyDiscount.bind(this);
    this.removeDiscount = this.removeDiscount.bind(this);
    this.abortController = null;
  }

  connectedCallback() {
    const form = this.querySelector('form[data-cart-discount]');
    if (form) {
      form.addEventListener('submit', this.applyDiscount);
    }
    this.querySelectorAll('.cart-discount__pill').forEach(pill => {
      pill.addEventListener('click', this.removeDiscount);
      pill.addEventListener('keydown', this.removeDiscount);
    });
  }

  disconnectedCallback() {
    const form = this.querySelector('form[data-cart-discount]');
    if (form) {
      form.removeEventListener('submit', this.applyDiscount);
    }
    this.querySelectorAll('.cart-discount__pill').forEach(pill => {
      pill.removeEventListener('click', this.removeDiscount);
      pill.removeEventListener('keydown', this.removeDiscount);
    });
  }

  get sectionId() {
    return this.dataset.sectionId;
  }

  get errorContainer() {
    return this.querySelector('.cart-discount__error');
  }

  get errorDiscount() {
    return this.querySelector('.cart-discount__error--discount');
  }

  get errorShipping() {
    return this.querySelector('.cart-discount__error--shipping');
  }

  get discountInput() {
    return this.querySelector('input[name="discount"]');
  }

  get existingDiscounts() {
    return Array.from(this.querySelectorAll('.cart-discount__pill'))
      .map(pill => pill.dataset.discountCode)
      .filter(Boolean);
  }

  abortActiveFetch() {
    if (this.abortController) {
      this.abortController.abort();
    }
    this.abortController = new AbortController();
    return this.abortController;
  }

  async applyDiscount(event) {
    event.preventDefault();
    event.stopPropagation();

    const discountCode = this.discountInput?.value?.trim();
    if (!discountCode || !this.sectionId) return;

    if (this.existingDiscounts.includes(discountCode)) return;

    this.hideErrors();

    const abortController = this.abortActiveFetch();
    try {
      const response = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          discount: [...this.existingDiscounts, discountCode].join(','),
          sections: [this.sectionId]
        }),
        signal: abortController.signal
      });

      const data = await response.json();

      // Check for invalid discount
      if (
        data.discount_codes &&
        data.discount_codes.some(
          d => d.code === discountCode && d.applicable === false
        )
      ) {
        this.discountInput.value = '';
        this.showError('discount');
        return;
      }

      // Check for shipping discount error
      const parser = new DOMParser();
      const html = data.sections[this.sectionId];
      const doc = parser.parseFromString(html, 'text/html');
      const pills = doc.querySelectorAll('.cart-discount__pill');
      const codes = Array.from(pills)
        .map(el => el.dataset.discountCode)
        .filter(Boolean);
      if (
        codes.length === this.existingDiscounts.length &&
        codes.every(code => this.existingDiscounts.includes(code)) &&
        data.discount_codes &&
        data.discount_codes.some(
          d => d.code === discountCode && d.applicable === true
        )
      ) {
        this.showError('shipping');
        this.discountInput.value = '';
        return;
      }

      document.dispatchEvent(new CustomEvent("cart:refresh"));
    } catch (e) {
      console.error('Error applying discount:', e);
      // Optionally handle error
    } finally {
      this.abortController = null;
    }
  }

  async removeDiscount(event) {
    if (
      (event instanceof KeyboardEvent && event.key !== 'Enter') ||
      !(event instanceof MouseEvent || event instanceof KeyboardEvent)
    ) {
      return;
    }

    const pill = event.target.closest('.cart-discount__pill');
    if (!pill) return;

    const code = pill.dataset.discountCode;
    if (!code) return;

    const discounts = this.existingDiscounts.filter(d => d !== code);

    const abortController = this.abortActiveFetch();

    try {
      const response = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          discount: discounts.join(','),
          sections: [this.sectionId]
        }),
        signal: abortController.signal
      });

      document.dispatchEvent(new CustomEvent("cart:refresh"));
    } catch (e) {
      // Optionally handle error
    } finally {
      this.abortController = null;
    }
  }

  showError(type) {
    if (this.errorContainer) this.errorContainer.classList.remove('hidden');
    if (type === 'discount' && this.errorDiscount) this.errorDiscount.classList.remove('hidden');
    if (type === 'shipping' && this.errorShipping) this.errorShipping.classList.remove('hidden');
  }

  hideErrors() {
    if (this.errorContainer) this.errorContainer.classList.add('hidden');
    if (this.errorDiscount) this.errorDiscount.classList.add('hidden');
    if (this.errorShipping) this.errorShipping.classList.add('hidden');
  }

  replaceSection(html) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const section = doc.getElementById(`shopify-section-${this.sectionId}`);
    if (section) {
      const currentSection = document.getElementById(`shopify-section-${this.sectionId}`);
      if (currentSection) {
        currentSection.replaceWith(section);
      }
    }
  }
}

if (!customElements.get('cart-discount-component')) {
  customElements.define('cart-discount-component', CartDiscountComponent);
}


let klarnaAttributes = null;

// Snapshot while the initialised element is still in the DOM; a re-render discards it.
function rememberKlarnaAttributes() {
  const placement = document.querySelector('klarna-placement[data-locale]');
  if (placement) klarnaAttributes = { ...placement.dataset };
}

window.addEventListener('load', rememberKlarnaAttributes);

function initKlarnaPlacements() {
  rememberKlarnaAttributes();
  if (!klarnaAttributes) return;

  let changed = false;

  document.querySelectorAll('[id^="shopify-block-"][id*="klarna"]').forEach(block => {
    const placement = block.querySelector('klarna-placement');
    if (!placement) return;

    // The block's inline config (read as text, never executed) carries this render's
    // price in minor units.
    const config = Array.from(block.querySelectorAll('script'))
      .map(script => script.textContent)
      .join('');
    const variantPrice = config.match(/variantPrice:\s*'(\d+)'/)?.[1];

    // Nothing to do when this placement is already initialised for this price, so a
    // rerender that leaves the markup alone does not cost a re-fetch.
    if (placement.dataset.locale && (!variantPrice || placement.dataset.purchaseAmount === variantPrice)) {
      return;
    }

    // Build the placement from scratch rather than patching the swapped-in one. The SDK
    // keys rendered placements by id, so refreshing an element that carries an id it has
    // already served does nothing — it keeps the empty span and logs "No content found
    // for the given configuration". A brand new node is treated as a new placement.
    const fresh = document.createElement('klarna-placement');
    Array.from(placement.attributes).forEach(attribute => {
      fresh.setAttribute(attribute.name, attribute.value);
    });

    // Restore what the app embed had set and this render is missing (data-locale above
    // all), leaving attributes the block itself renders untouched.
    Object.entries(klarnaAttributes).forEach(([key, value]) => {
      if (fresh.dataset[key] === undefined || fresh.dataset[key] === '') {
        fresh.dataset[key] = value;
      }
    });

    if (variantPrice) fresh.dataset.purchaseAmount = variantPrice;

    placement.replaceWith(fresh);
    changed = true;
  });

  if (!changed) return;

  if (window.Klarna?.OnsiteMessaging?.refresh) {
    window.Klarna.OnsiteMessaging.refresh();
  } else {
    window.KlarnaOnsiteService = window.KlarnaOnsiteService || [];
    window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' });
  }
}

// Covers every path that replaces the placement: the connector picker below, and the
// theme's own product-rerender on variant change (which can land after ours).
document.addEventListener('product:rerender', initKlarnaPlacements);

// reviews.io renders its star snippets once on load (ratingSnippet) and the Polaris widget
// from an inline script, and neither runs for HTML swapped in without a page load.
function refreshReviewsIo(event) {
  // Stars: ratingSnippet() skips snippets it already rendered ([data-retrieved]), so
  // re-running it with the app's own settings only fills in the new ones.
  window.reinitialiseRatingSnippet?.();

  // Polaris sits outside product-rerender, so it still shows the previous product. Swap
  // its app block for the new page's one and run the inline init script again (scripts
  // inserted from parsed HTML never execute on their own).
  const htmlFragment = event.detail?.htmlFragment;
  if (!htmlFragment?.querySelectorAll) return;

  htmlFragment.querySelectorAll('.shopify-app-block[id*="reviewsio_polaris"]').forEach(newBlock => {
    const currentBlock = document.getElementById(newBlock.id);
    if (!currentBlock) return;

    const freshBlock = document.importNode(newBlock, true);
    freshBlock.querySelectorAll('script').forEach(inertScript => {
      if (inertScript.src) return; // the widget library is already loaded on this page
      const script = document.createElement('script');
      script.textContent = inertScript.textContent;
      inertScript.replaceWith(script);
    });
    currentBlock.replaceWith(freshBlock);
  });
}

document.addEventListener('product:rerender', refreshReviewsIo);

// Module-level so preloaded pages survive the picker being re-rendered on each switch.
const connectorProductCache = new Map(); // url -> Promise of Document

// Module-level for the same reason: the picker that started a switch is replaced mid-switch,
// so the lock has to outlive it. While set, further swatch clicks are ignored.
let connectorSwitchInProgress = false;

// Must match the duration of `.thumbnail-swatch.is-loaded` in theme.css.
const CONNECTOR_PROGRESS_COMPLETE_MS = 200;

class ConnectorPicker extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.querySelectorAll('input[data-product-url]').forEach(link => {
      const productUrl = link.getAttribute('data-product-url');

      link.addEventListener('click', (event) => {
        event.preventDefault();

        // Ignore repeated clicks / taps while a product is loading, and clicks on the current product.
        const swatch = link.labels?.[0];
        if (connectorSwitchInProgress || swatch?.classList.contains('is-selected')) return;

        this.loadProduct(productUrl, swatch);
      });

      // Preload on hover / keyboard focus so switching is nearly instant.
      // The input is usually visually hidden, so listen on its label too.
      const preload = () => this.fetchProduct(productUrl).catch(() => {});
      link.labels?.forEach(label => label.addEventListener('pointerenter', preload, { once: true }));
      link.addEventListener('focus', preload, { once: true });
    });

    this.initColorNamePreview();
  }

  buildProductUrl(productUrl) {
    const searchParams = new URLSearchParams(window.location.search);
    if (searchParams.get('sizesfor')) {
      productUrl += `?${searchParams.toString()}`;
    }
    return productUrl;
  }

  fetchProduct(productUrl) {
    const url = this.buildProductUrl(productUrl);
    if (!connectorProductCache.has(url)) {
      const promise = fetch(new URL(url, window.location.origin).toString())
        .then(response => {
          if (!response.ok) throw new Error(`HTTP ${response.status}`);
          return response.text();
        })
        .then(html => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          return { doc, imagesReady: this.warmImages(doc) };
        })
        .catch(error => {
          connectorProductCache.delete(url); // allow a retry
          throw error;
        });
      connectorProductCache.set(url, promise);
    }
    return connectorProductCache.get(url);
  }

  // Start downloading the first few images of the new page (the above-the-fold
  // gallery) so they are decoded before we swap, which avoids layout jumps.
  warmImages(doc, limit = 4) {
    const images = [...doc.querySelectorAll('product-rerender img')].slice(0, limit);
    return Promise.all(images.map(source => {
      const img = new Image();
      if (source.sizes) img.sizes = source.sizes;
      if (source.srcset) img.srcset = source.srcset;
      img.src = source.src;
      return img.decode().catch(() => {});
    }));
  }

  // On hover over a thumbnail swatch, preview that swatch's color name in the
  // picker title, restoring the selected product's name on mouse out.
  initColorNamePreview() {
    const colorNameTarget = this.querySelector('[data-connector-color-name]');
    if (!colorNameTarget) return;

    const originalColorName = colorNameTarget.textContent.trim();
 
    this.querySelectorAll('.thumbnail-swatch[data-color-name]').forEach(swatch => {
      swatch.addEventListener('mouseenter', () => {
        const colorName = swatch.getAttribute('data-color-name').trim();
        if (colorName) colorNameTarget.textContent = colorName;
      });
      swatch.addEventListener('mouseleave', () => {
        colorNameTarget.textContent = originalColorName;
      });
    });
  } 

  // Loading state on the clicked swatch: a gray overlay plus a ring that fills around the
  // circle (styled in theme.css). The ring eases towards 90% while we wait, and
  // completeLoadingState() fills the rest just before the content is swapped.
  startLoadingState(swatch) {
    this.setAttribute('aria-busy', 'true');
    swatch?.classList.add('is-loading');
  }

  completeLoadingState(swatch) {
    if (!swatch) return Promise.resolve();
    swatch.classList.add('is-loaded');
    return new Promise(resolve => setTimeout(resolve, CONNECTOR_PROGRESS_COMPLETE_MS));
  }

  clearLoadingState(swatch) {
    this.removeAttribute('aria-busy');
    swatch?.classList.remove('is-loading', 'is-loaded');
  }

  async loadProduct(productUrl, swatch) {
    const baseUrl = productUrl;
    productUrl = this.buildProductUrl(productUrl);
    const productRerender = this.closest('product-rerender') || document.querySelector('product-rerender');
    if (!productRerender) {
    //  window.location.href = productUrl;
      return;
    }

    connectorSwitchInProgress = true;
    this.startLoadingState(swatch);
    let navigating = false;

    try {
      document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start", { bubbles: true }));
      var selected_size = productRerender.querySelector('.input-swatch-size:checked + label')?.getAttribute('data-original');
      const { doc: cachedDoc, imagesReady } = await this.fetchProduct(baseUrl);
      // Clone so the cached document stays intact for later switches.
      const doc = cachedDoc.cloneNode(true);
      const newContent = doc.querySelector('product-rerender');

      if (newContent && productRerender) {
        // Wait for the key images, but never hold the switch for more than 800ms.
        await Promise.race([imagesReady, new Promise(resolve => setTimeout(resolve, 800))]);

        // Let the ring reach 100% before the swatch is replaced by the new content.
        await this.completeLoadingState(swatch);

        const swapContent = () => {
          // Hold on to the locale while the initialised placement is still in the DOM.
          rememberKlarnaAttributes();
          productRerender.innerHTML = newContent.innerHTML;
          if (selected_size) {
            const sizeSwatches = productRerender.querySelectorAll('.input-swatch-size + label');
            sizeSwatches.forEach(swatch => {
              if (swatch.getAttribute('data-original') === selected_size) {
                swatch.click();
              }
            });
          }
        };

        // Cross-fade: the browser snapshots the old product area as an overlay, swaps
        // the DOM underneath, then fades the snapshot out over the new content.
        // Only the product area is captured (root is opted out), so the header and
        // the rest of the page stay live and do not fade.
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (document.startViewTransition && !reduceMotion) {
          const root = document.documentElement;
          // product-rerender is inline, so name its block-level child instead. The gallery
          // gets its own name so theme.css can fade it out then in (connector-gallery).
          const setTransitionNames = (enabled) => {
            const product = productRerender.firstElementChild;
            const gallery = product?.querySelector(':scope > .product-gallery');
            if (product) product.style.viewTransitionName = enabled ? 'connector-product' : '';
            if (gallery) gallery.style.viewTransitionName = enabled ? 'connector-gallery' : '';
          };

          // The transition layer paints above the live page, so the product snapshot would
          // cover the sticky header / announcement bar while scrolled. Capturing them too
          // keeps their paint order (higher z-index), so they stay on top unchanged.
          const stickySections = [...document.querySelectorAll('.shopify-section--announcement-bar, .shopify-section--header')];

          root.style.viewTransitionName = 'none';
          stickySections.forEach((section, index) => section.style.viewTransitionName = `connector-sticky-${index}`);
          setTransitionNames(true);

          const transition = document.startViewTransition(() => {
            swapContent();
            setTransitionNames(true); // the new content needs the same names
          });
          transition.ready.catch(() => {}); // a skipped transition is fine, the swap still runs
          transition.finished.finally(() => {
            root.style.viewTransitionName = '';
            stickySections.forEach(section => section.style.viewTransitionName = '');
            setTransitionNames(false);
          });

          await transition.updateCallbackDone;
        } else {
          swapContent();
        }

        // Update the browser URL without a full page reload
        window.history.pushState({}, '', productUrl);

        // Dispatch rerender event so other components can react
        // (this is also what re-initialises the Klarna placement)
        document.dispatchEvent(new CustomEvent('product:rerender', {
          detail: { htmlFragment: doc }
        }));
      } else {
        navigating = true;
        window.location.href = productUrl;
      }
    } catch (e) {
      navigating = true;
      window.location.href = productUrl;
    } finally {
      document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
      // On a successful swap the swatch is already gone; on a fallback navigation keep the
      // loading state (and the lock) so the swatch stays busy until the new page loads.
      if (!navigating) {
        this.clearLoadingState(swatch);
        connectorSwitchInProgress = false;
      }
    }
  }
}

if (!customElements.get('connector-picker')) {
  customElements.define('connector-picker', ConnectorPicker);
}

// A fallback navigation leaves the swatch busy; if the user comes back via the
// back/forward cache, the page is restored in that state, so reset it.
window.addEventListener('pageshow', (event) => {
  if (!event.persisted) return;
  connectorSwitchInProgress = false;
  document.querySelectorAll('connector-picker').forEach(picker => picker.removeAttribute('aria-busy'));
  document.querySelectorAll('connector-picker .is-loading').forEach(swatch => swatch.classList.remove('is-loading', 'is-loaded'));
});

import { AccordionDisclosure } from 'theme';

class UpsaleAccordionDisclosure extends AccordionDisclosure {
  connectedCallback() {
    super.connectedCallback();
    this._onSwatchClick = this._onSwatchClick.bind(this);
    // Use capture so we intercept before the click reaches summary and toggles the accordion
    this.addEventListener('click', this._onSwatchClick, { capture: true });
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener('click', this._onSwatchClick, { capture: true });
  }

  _onSwatchClick(event) {
    const swatch = event.target.closest('.thumbnail-swatch');
    if (!swatch) return;
    // Prevent the click reaching summary so it never toggles the accordion
    event.preventDefault();
    event.stopPropagation();

    if (!this.disclosureElement.open) this.open();

    if (swatch.classList.contains('is-selected')) return;

    this.querySelectorAll('.thumbnail-swatch').forEach(s => s.classList.remove('is-selected'));
    swatch.classList.add('is-selected');

    const handle = swatch.dataset.collection;
    this.querySelectorAll('.cart-drawer__upsale-group').forEach(group => {
      group.hidden = group.dataset.collection !== handle;
    });
  }
}

if (!customElements.get('upsale-accordion-disclosure')) {
  customElements.define('upsale-accordion-disclosure', UpsaleAccordionDisclosure);
}

document.addEventListener('dialog:after-show', function(event) {
  if (event.target && event.target.id === 'cart-drawer') {
    event.target.querySelectorAll('.icon--pulse').forEach(function(el) {
      el.style.animation = 'none';
      el.offsetWidth; // force reflow
      el.style.animation = '';
    });
  }
});

// Adjust Gorgias chat iframe position based on product sticky bar visibility
function adjustGorgiasChatPosition() {
  const stickyBar = document.querySelector('.product-sticky-bar');
  const chatIframe = document.getElementById('chat-button');

  if (!chatIframe) return;

  if (stickyBar && stickyBar.classList.contains('is-visible')) {
    const stickyBarHeight = stickyBar.offsetHeight;
    chatIframe.style.bottom = (20 + stickyBarHeight) + 'px';
  } else {
    chatIframe.style.bottom = '20px';
  }
}

// Watch for sticky bar visibility changes
const stickyBar = document.querySelector('.product-sticky-bar');
if (stickyBar) {
  const observer = new MutationObserver(adjustGorgiasChatPosition);
  observer.observe(stickyBar, { attributes: true, attributeFilter: ['class'] });
}

// Initial adjustment
adjustGorgiasChatPosition();

// Also adjust on window resize
window.addEventListener('resize', adjustGorgiasChatPosition);

// Help-centre chat calls to action. The Account & Support design mocked up its own chat
// bubble; the store already runs Gorgias, so these open the real widget rather than
// shipping a second one that looks live but is not.
//
// Any element carrying data-help-chat becomes a trigger. Give it an href as well (a
// mailto is the sensible one) so the control still does something useful when Gorgias is
// blocked by an ad blocker or has not finished loading.
document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-help-chat]');

  if (!trigger) {
    return;
  }

  // Let the browser handle open-in-new-tab and anything already cancelled upstream.
  if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
    return;
  }

  if (window.GorgiasChat && typeof window.GorgiasChat.open === 'function') {
    event.preventDefault();
    window.GorgiasChat.open();
    return;
  }

  // Otherwise fall through to the element's own href, which is a mailto. There is
  // deliberately no #chat-button fallback: that element is Gorgias's launcher IFRAME, and
  // .click() on an iframe does not reach the cross-origin document inside it — it would
  // cancel the mailto and open nothing.
});



// Type-ahead for listboxes (e.g. country selector): typing letters focuses the first matching option
(() => {
  let buffer = '';
  let resetTimer;

  document.addEventListener('keydown', (event) => {
    const listbox = event.target.closest?.('x-listbox[data-typeahead]');
    if (!listbox || event.ctrlKey || event.metaKey || event.altKey || event.key.length !== 1) return;
    if (event.key === ' ' && !buffer) return; // keep Space for selecting the option

    event.preventDefault();
    clearTimeout(resetTimer);
    resetTimer = setTimeout(() => (buffer = ''), 700);
    buffer += event.key.toLowerCase();

    const normalize = (str) => str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
    const options = Array.from(listbox.querySelectorAll('[role="option"]'));
    const label = (option) => normalize(option.dataset.typeaheadLabel || option.textContent.trim());
    const query = normalize(buffer);

    // Repeating the same letter cycles through options starting with it
    const isRepeat = query.length > 1 && [...query].every((char) => char === query[0]);
    const current = options.indexOf(document.activeElement);
    let match;

    if (isRepeat) {
      const candidates = options.filter((option) => label(option).startsWith(query[0]));
      match = candidates[(candidates.indexOf(document.activeElement) + 1) % candidates.length];
    } else {
      match = options.find((option) => label(option).startsWith(query));
      if (!match && query.length === 1) {
        match = options.slice(current + 1).concat(options.slice(0, current + 1)).find((option) => label(option).startsWith(query));
      }
    }

    match?.focus();
    match?.scrollIntoView({ block: 'nearest' });
  });
})();

/**
 * Complete the fit (sections/complete-the-fit.liquid): current product + selectable add-ons, added to cart in one request.
 * Add-ons are rendered hidden for both genders; one random add-on per category is shown for the gender picked in the
 * product page's men/women switcher (gender-size-switcher).
 * The discount shown is display-only; the matching automatic discount is configured in Shopify admin.
 */
function formatMoney(cents, format = window.themeVariables.settings.currencyCodeEnabled ? window.themeVariables.settings.moneyWithCurrencyFormat : window.themeVariables.settings.moneyFormat) {
  const formatAmount = (value, precision, thousands = ',', decimal = '.') => {
    const [integer, fraction] = (value / 100).toFixed(precision).split('.');
    return integer.replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (fraction ? decimal + fraction : '');
  };

  return format.replace(/\{\{\s*(\w+)\s*\}\}/, (match, placeholder) => {
    switch (placeholder) {
      case 'amount_no_decimals': return formatAmount(cents, 0);
      case 'amount_with_comma_separator': return formatAmount(cents, 2, '.', ',');
      case 'amount_no_decimals_with_comma_separator': return formatAmount(cents, 0, '.', ',');
      case 'amount_with_apostrophe_separator': return formatAmount(cents, 2, "'", '.');
      case 'amount_with_space_separator': return formatAmount(cents, 2, ' ', ',');
      default: return formatAmount(cents, 2);
    }
  });
}

class CompleteTheFit extends HTMLElement {
  connectedCallback() {
    this.abortController = new AbortController();
    const { signal } = this.abortController;

    this.addEventListener('change', this.onChange.bind(this), { signal });
    this.addEventListener('click', this.onCardClick.bind(this), { signal });
    this.submitButton.addEventListener('click', this.addToCart.bind(this), { signal });
    document.addEventListener('variant:change', this.onMainVariantChange.bind(this), { signal });
    document.addEventListener('gender:change', this.onGenderChange.bind(this), { signal });

    // Product cards show product-level prices ("from" or highest), so align them with the variant the bundle adds
    this.querySelectorAll('[data-bundle-item]').forEach((item) => this.renderCardPrice(item));

    // The switcher restores ?sizesfor= on load before this element exists, so read it here as well
    this.chosenAddons = {};
    this.showGender(new URLSearchParams(window.location.search).get('sizesfor') || this.getAttribute('default-gender'));
  }

  disconnectedCallback() {
    this.abortController.abort();
  }

  // Only the add-ons shown for the current gender take part in the bundle
  get items() {
    return Array.from(this.querySelectorAll('[data-bundle-item]:not([hidden])'));
  }

  get carousel() {
    return this.querySelector('scroll-carousel');
  }

  get mainItem() {
    return this.querySelector('[data-bundle-main]');
  }

  get selectedItems() {
    return this.items.filter((item) => item === this.mainItem || item.querySelector('input[type="checkbox"]')?.checked);
  }

  get submitButton() {
    return this.querySelector('.complete-the-fit__submit button');
  }

  get mainSelectionReady() {
    const picker = document.querySelector(`variant-picker[form-id^="${this.getAttribute('main-form')}"]`);
    if (!picker) return true;
    const variant = picker.selectedVariant;
    const sizeOption = picker.querySelector('.input-swatch-size');
    const selectedSize = picker.querySelector('.input-swatch-size:checked');
    if (sizeOption && !selectedSize) return false;
    const selectedLabel = selectedSize?.labels?.[0]?.dataset.original;
    return !!variant?.id && (!selectedLabel || variant.options?.includes(selectedLabel));
  }

  onGenderChange(event) {
    const swatch = event.detail?.swatch;

    // Quick buy modals and collection filters have their own switchers
    if (!swatch || swatch.closest('.quick-buy-modal, facets-form')) {
      return;
    }

    this.showGender(swatch.textContent.trim().toLowerCase());
  }

  showGender(gender) {
    const addons = Array.from(this.querySelectorAll('[data-bundle-addon]'));

    // Products without a men's/women's split (e.g. unisex) fall back to the men's add-ons
    if (!addons.some((addon) => addon.dataset.gender === gender)) {
      gender = 'mens';
    }

    if (gender === this.gender) {
      return;
    }

    // Keep each gender's random pick, so toggling back and forth doesn't reshuffle the add-ons
    if (!this.chosenAddons[gender]) {
      const categories = new Map();

      addons.filter((addon) => addon.dataset.gender === gender).forEach((addon) => {
        categories.set(addon.dataset.category, [...(categories.get(addon.dataset.category) || []), addon]);
      });

      this.chosenAddons[gender] = Array.from(categories.values(), (candidates) => candidates[Math.floor(Math.random() * candidates.length)]);
    }

    const chosen = this.chosenAddons[gender], isFirstRender = this.gender === undefined;

    this.gender = gender;

    // A gender switch starts the bundle over with no add-ons ticked; the preselect only applies on page load
    addons.forEach((addon) => {
      addon.hidden = !chosen.includes(addon);
      addon.querySelector('input[type="checkbox"]').checked = false;
    });

    if (isFirstRender && chosen.length > 0 && this.hasAttribute('preselect-first')) {
      chosen[0].querySelector('input[type="checkbox"]').checked = true;
    }

    this.closest('.complete-the-fit-section').hidden = chosen.length === 0;
    this.style.setProperty('--complete-the-fit-columns', Math.min(chosen.length + 1, 4));

    // Showing/hiding cells doesn't resize the carousel, so its own resize handling doesn't refresh the arrows
    requestAnimationFrame(() => {
      this.carousel.classList.toggle('is-scrollable', this.carousel.scrollWidth > this.carousel.clientWidth);

      if (chosen.length > 0) {
        this.carousel.select(0, { instant: true });
      }
    });

    this.syncSizes(JSON.parse(this.mainItem.dataset.optionValues));
    this.update();
  }

  // Cards are rendered without links here, so clicking an add-on card toggles it in the bundle
  onCardClick(event) {
    // The add-on carousel cancels the click that ends a drag, so dragging doesn't toggle the card
    if (event.defaultPrevented) {
      return;
    }

    const checkbox = event.target.closest('[data-bundle-item]')?.querySelector('input[type="checkbox"]');

    if (!checkbox || !event.target.closest('.product-card')) {
      return;
    }

    checkbox.checked = !checkbox.checked;
    checkbox.dispatchEvent(new Event('change', { bubbles: true }));
  }

  onChange(event) {
    const item = event.target.closest('[data-bundle-item]');

    if (event.target.matches('select')) {
      this.selectOption(item, event.target.selectedOptions[0]);
    }

    this.update();
  }

  selectOption(item, option) {
    item.dataset.variantId = option.value;
    item.dataset.price = option.dataset.price;
    item.dataset.compareAtPrice = option.dataset.compareAtPrice;

    this.renderCardPrice(item);
    this.renderCardImage(item, option.dataset.image);
  }

  // Moves every add-on to the same size as the main product, when that size exists and is available for it
  syncSizes(mainOptionValues) {
    const sizeIndex = (optionNames) => optionNames.findIndex((name) => name.toLowerCase() === 'size');
    const mainSizeIndex = sizeIndex(JSON.parse(this.mainItem.dataset.optionNames));
    const size = mainOptionValues?.[mainSizeIndex];

    if (mainSizeIndex === -1 || !size) {
      return;
    }

    this.items.filter((item) => item !== this.mainItem).forEach((item) => {
      const select = item.querySelector('select'), addonSizeIndex = sizeIndex(JSON.parse(item.dataset.optionNames));

      if (!select || addonSizeIndex === -1) {
        return;
      }

      // Among the variants in that size, prefer the one that keeps the add-on's other options (e.g. colour) unchanged
      const currentValues = JSON.parse(select.selectedOptions[0].dataset.optionValues);
      const candidates = Array.from(select.options).filter((option) => !option.disabled && JSON.parse(option.dataset.optionValues)[addonSizeIndex] === size);
      const match = candidates.find((option) => JSON.parse(option.dataset.optionValues).every((value, index) => index === addonSizeIndex || value === currentValues[index])) || candidates[0];

      if (match && !match.selected) {
        select.value = match.value;
        this.selectOption(item, match);
      }
    });
  }

  onMainVariantChange(event) {
    // event.detail.formId is the form's "id" input element (form.id), not its id attribute, so read it from the form itself
    const { variant } = event.detail;
    const formId = event.target.getAttribute?.('id');

    if (!formId?.startsWith(this.getAttribute('main-form'))) {
      return;
    }

    this.applyMainVariant(variant);
  }

  // Re-syncs "This item" with whatever the main variant picker currently has selected
  syncWithMainPicker() {
    const variant = document.querySelector(`variant-picker[form-id^="${this.getAttribute('main-form')}"]`)?.selectedVariant;

    // The picker holds an empty object until a size is chosen, so keep the server-rendered variant then
    if (variant?.id) {
      this.applyMainVariant(variant);
    }
  }

  applyMainVariant(variant) {
    const main = this.mainItem;
    main.dataset.available = !!variant?.available;

    if (variant) {
      main.dataset.variantId = variant.id;
      main.dataset.price = variant.price;
      main.dataset.compareAtPrice = variant.compare_at_price || 0;

      const title = main.querySelector('[data-bundle-main-variant-title]');
      if (title) {
        title.textContent = variant.title;
      }

      main.dataset.optionValues = JSON.stringify(variant.options);

      this.renderCardPrice(main);
      this.renderCardImage(main, variant.featured_media?.preview_image?.src);
      this.syncSizes(variant.options);
    }

    this.update();
  }

  // Mirrors the variant case of snippets/price-list.liquid
  renderCardPrice(item) {
    const priceList = item.querySelector('price-list'), salePrice = priceList?.querySelector('sale-price');

    if (!salePrice) {
      return;
    }

    const price = parseInt(item.dataset.price), compareAtPrice = parseInt(item.dataset.compareAtPrice) || 0, isOnSale = compareAtPrice > price;
    const textClass = salePrice.classList.contains('h6') ? 'h6 ' : '';

    salePrice.className = textClass + (isOnSale ? 'text-on-sale' : 'text-subdued');
    salePrice.replaceChildren(salePrice.querySelector('.sr-only'), formatMoney(price));

    let compareAt = priceList.querySelector('compare-at-price');

    if (!isOnSale) {
      compareAt?.remove();
      return;
    }

    if (!compareAt) {
      compareAt = document.createElement('compare-at-price');
      compareAt.className = `${textClass}text-subdued line-through`;
      priceList.append(compareAt);
    }

    const srOnly = document.createElement('span');
    srOnly.className = 'sr-only';
    srOnly.textContent = this.getAttribute('regular-price-label');
    compareAt.replaceChildren(srOnly, formatMoney(compareAtPrice));
  }

  renderCardImage(item, imageSrc) {
    const image = item.querySelector('.product-card__image--primary');

    if (!image || !imageSrc) {
      return;
    }

    const url = new URL(imageSrc, window.location.href);
    image.srcset = [200, 300, 400, 500, 600, 700, 800, 1000, 1200].map((width) => {
      url.searchParams.set('width', width);
      return `${url.toString()} ${width}w`;
    }).join(', ');
    image.src = url.toString();
  }

  update() {
    const selected = this.selectedItems, addonsCount = selected.length - 1;
    const subtotal = selected.reduce((total, item) => total + parseInt(item.dataset.price), 0);
    const discountPercent = parseInt(this.getAttribute('discount-percent')) || 0;
    const savings = addonsCount > 0 ? Math.round(subtotal * discountPercent / 100) : 0;

    this.items.forEach((item) => item.classList.toggle('is-selected', selected.includes(item)));

    this.querySelector('[data-bundle-total]').textContent = `${this.getAttribute('items-count-label').replace('[count]', selected.length)} · ${formatMoney(subtotal - savings)}`;

    const compare = this.querySelector('[data-bundle-compare]'), savingsLabel = this.querySelector('[data-bundle-savings]');
    compare.hidden = savingsLabel.hidden = savings === 0;
    compare.textContent = formatMoney(subtotal);
    savingsLabel.textContent = this.getAttribute('save-label').replace('[amount]', formatMoney(savings));

    const selectionReady = this.mainSelectionReady;
    this.submitButton.disabled = !selectionReady || this.mainItem.dataset.available !== 'true';
    if (!selectionReady) {
      const title = this.mainItem.querySelector('[data-bundle-main-variant-title]');
      if (title) title.textContent = this.getAttribute('choose-size-label');
    }
  }

  async addToCart() {
    const errorElement = this.querySelector('[data-bundle-error]');
    errorElement.hidden = true;
    this.syncWithMainPicker();
    if (!this.mainSelectionReady || this.mainItem.dataset.available !== 'true') {
      this.update();
      errorElement.textContent = this.getAttribute('choose-size-label');
      errorElement.hidden = false;
      return;
    }

    this.submitButton.setAttribute('aria-busy', 'true');
    document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));

    let sectionsToBundle = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sectionsToBundle } }));

    const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({
        items: this.selectedItems.map((item) => ({ id: parseInt(item.dataset.variantId), quantity: 1 })),
        sections: sectionsToBundle.join(',')
      })
    });

    const responseJson = await response.json();

    this.submitButton.removeAttribute('aria-busy');
    document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));

    if (!response.ok) {
      errorElement.textContent = responseJson['description'];
      errorElement.hidden = false;
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      return;
    }

    if (window.themeVariables.settings.cartType === 'page') {
      return window.location.href = `${Shopify.routes.root}cart`;
    }

    const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
    cartContent['sections'] = responseJson['sections'];

    document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
      bubbles: true,
      detail: {
        baseEvent: 'variant:add',
        cart: cartContent
      }
    }));
  }
}

if (!window.customElements.get('complete-the-fit')) {
  window.customElements.define('complete-the-fit', CompleteTheFit);
}

// The colour connector only swaps product-rerender, so "Complete the fit" (its own section) would keep showing,
// and adding, the previous product. Swap the section for the new page's one whenever the product changed.
document.addEventListener('product:rerender', (event) => {
  const htmlFragment = event.detail?.htmlFragment;
  if (!htmlFragment?.querySelectorAll) return;

  document.querySelectorAll('.shopify-section--complete-the-fit').forEach((section) => {
    const newSection = htmlFragment.querySelector(`#${CSS.escape(section.id)}`);

    // A template without the section: hide it rather than keep bundling the previous product
    if (!newSection) {
      section.hidden = true;
      return;
    }

    const currentMainForm = section.querySelector('complete-the-fit')?.getAttribute('main-form');
    const newMainForm = newSection.querySelector('complete-the-fit')?.getAttribute('main-form');

    if (currentMainForm === newMainForm) return;

    section.hidden = false;
    section.replaceChildren(...document.importNode(newSection, true).childNodes);

    // The connector re-selects the previous size before or after this runs, so read it from the picker as well
    section.querySelector('complete-the-fit')?.syncWithMainPicker();
  });
});

/**
 * Keeps the size note under the size grid in sync with the selected variant.
 *
 * The variant picker re-renders the whole block server side on an option change, so this only matters when the
 * variant is changed by something that does not replace this markup. The variant JSON carried by "variant:change"
 * has no inventory quantity, so the low stock variant ids are rendered into a data attribute by the Liquid snippet.
 */
class VariantSizeNote extends HTMLElement {
  connectedCallback() {
    this.abortController = new AbortController();

    document.addEventListener('variant:change', this.onVariantChange.bind(this), { signal: this.abortController.signal });
  }

  disconnectedCallback() {
    this.abortController.abort();
  }

  get note() {
    return this.querySelector('p');
  }

  get lowStockVariants() {
    return (this.dataset.lowStockVariants || '').split(',').filter(Boolean);
  }

  onVariantChange(event) {
    const form = event.target instanceof HTMLFormElement ? event.target : event.detail.formId?.form;

    if (form?.getAttribute('id') !== this.getAttribute('form')) {
      return;
    }

    this.render(event.detail.variant);
  }

  render(variant) {
    const note = this.note;

    if (!note) {
      return;
    }

    let text = this.dataset.noteDefault;
    let status = 'subdued';

    // The note is variant specific, so it stays generic until a variant is actually selected
    if (variant) {
      if (!variant.available) {
        text = this.dataset.noteSoldOut;
        status = 'error';
      } else if (this.lowStockVariants.includes(String(variant.id))) {
        text = this.dataset.noteLowStock;
        status = 'warning';
      }
    }

    note.textContent = text;
    note.classList.remove('text-subdued', 'text-warning', 'text-error');
    note.classList.add(`text-${status}`);
  }
}

if (!window.customElements.get('variant-size-note')) {
  window.customElements.define('variant-size-note', VariantSizeNote);
}


/**
 * Help centre search and topic filtering.
 *
 * Two elements rather than one, because the design puts the search field in the hero and
 * the results most of a page further down. They are coupled by events on `document`:
 *
 *   help:search   { query }          dispatched by help-search, consumed by help-topics
 *   help:results  { query, count }   dispatched by help-topics, consumed by help-search
 *   help:clear                       dispatched by help-topics when a category is picked
 *
 * Both enhance markup that already works: every article is rendered server-side and
 * visible, and the category chips are real links to the blog's tag pages. With JavaScript
 * off the section stays a complete, linked directory.
 */
(() => {
  const normalise = (value) => (value || '').trim().toLowerCase();

  class HelpSearch extends HTMLElement {
    constructor() {
      super();
      this.onInput = this.onInput.bind(this);
      this.onClear = this.onClear.bind(this);
      this.onResults = this.onResults.bind(this);
      this.onExternalClear = this.onExternalClear.bind(this);
    }

    connectedCallback() {
      this.input = this.querySelector('[data-help-search-input]');
      this.clearButton = this.querySelector('[data-help-search-clear]');
      this.status = this.querySelector('[data-help-search-status]');
      this.idleLabel = this.status ? this.status.textContent : '';
      this.hasJumped = false;

      this.input?.addEventListener('input', this.onInput);
      this.clearButton?.addEventListener('click', this.onClear);
      document.addEventListener('help:results', this.onResults);
      document.addEventListener('help:clear', this.onExternalClear);
    }

    disconnectedCallback() {
      clearTimeout(this.debounceTimer);
      this.input?.removeEventListener('input', this.onInput);
      this.clearButton?.removeEventListener('click', this.onClear);
      document.removeEventListener('help:results', this.onResults);
      document.removeEventListener('help:clear', this.onExternalClear);
    }

    onInput() {
      clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(() => this.announce(), 180);
    }

    announce() {
      const query = this.input.value.trim();

      this.clearButton?.toggleAttribute('hidden', query === '');
      document.dispatchEvent(new CustomEvent('help:search', { detail: { query: query } }));

      // Jump once, when a search begins. Re-jumping on every keystroke fights the
      // customer, and jumping when they clear the field would be disorienting.
      if (query !== '' && !this.hasJumped) {
        const target = document.getElementById(this.getAttribute('results-anchor') || '');
        target?.scrollIntoView({ block: 'start' });
        this.hasJumped = true;
      }

      if (query === '') {
        this.hasJumped = false;
      }
    }

    onClear() {
      this.input.value = '';
      this.announce();
      this.input.focus();
    }

    onExternalClear() {
      if (!this.input || this.input.value === '') return;

      this.input.value = '';
      this.clearButton?.toggleAttribute('hidden', true);
      this.hasJumped = false;

      if (this.status) this.status.textContent = this.idleLabel;
    }

    onResults(event) {
      if (!this.status) return;

      const query = event.detail.query;
      const count = event.detail.count;

      if (query === '') {
        this.status.textContent = this.idleLabel;
        return;
      }

      const template = count === 1
        ? this.getAttribute('result-label')
        : this.getAttribute('results-label');

      this.status.textContent = (template || '')
        .replace('[count]', count)
        .replace('[query]', query);
    }
  }

  class HelpTopics extends HTMLElement {
    constructor() {
      super();
      this.onChipClick = this.onChipClick.bind(this);
      this.onSearch = this.onSearch.bind(this);
    }

    connectedCallback() {
      this.articles = Array.from(this.querySelectorAll('[data-help-article]'));
      this.chips = Array.from(this.querySelectorAll('[data-help-chip]'));
      this.empty = this.querySelector('[data-help-topics-empty]');
      this.results = this.querySelector('[data-help-topics-results]');
      this.emptyQuery = this.querySelector('[data-help-empty-query]');
      this.headingElement = this.querySelector('[data-help-topics-heading]');
      this.subheadingElement = this.querySelector('[data-help-topics-subheading]');

      this.query = '';
      this.category = '';

      this.chips.forEach((chip) => chip.addEventListener('click', this.onChipClick));
      document.addEventListener('help:search', this.onSearch);

      this.apply();
    }

    disconnectedCallback() {
      this.chips.forEach((chip) => chip.removeEventListener('click', this.onChipClick));
      document.removeEventListener('help:search', this.onSearch);
    }

    onChipClick(event) {
      // The chips are real links to the blog's tag pages so they work without JavaScript.
      // With it, filter in place instead of navigating away from the help centre — but let
      // ctrl/cmd/shift-click through, so opening a tag page in a new tab still works.
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
        return;
      }

      event.preventDefault();

      this.category = event.currentTarget.dataset.category || '';
      this.query = '';
      document.dispatchEvent(new CustomEvent('help:clear'));
      this.apply();
    }

    onSearch(event) {
      this.query = normalise(event.detail.query);

      // A search looks across every category, so it supersedes the chip selection.
      if (this.query !== '') this.category = '';

      this.apply();
    }

    matches(article) {
      if (this.query !== '') {
        return (article.dataset.search || '').includes(this.query);
      }

      if (this.category !== '') {
        // Cards carry every tag, pipe-delimited, because an article's category chip is not
        // necessarily its first tag — matching on first tag only would hide articles that
        // the equivalent server-rendered tag page lists.
        return ('|' + (article.dataset.category || '') + '|').indexOf('|' + this.category + '|') !== -1;
      }

      return true;
    }

    apply() {
      const searching = this.query !== '';
      let count = 0;

      this.articles.forEach((article) => {
        const visible = this.matches(article);
        article.toggleAttribute('hidden', !visible);
        if (visible) count += 1;
      });

      // Cards only show their category while searching, when results span categories.
      this.classList.toggle('help-topics--searching', searching);

      this.chips.forEach((chip) => {
        const active = !searching && (chip.dataset.category || '') === this.category;
        // aria-current, not aria-pressed: these are links, and aria-pressed is only valid
        // on button-like roles, so it would never be announced.
        if (active) {
          chip.setAttribute('aria-current', 'true');
        } else {
          chip.removeAttribute('aria-current');
        }
        chip.classList.toggle('is-selected', active);
      });

      if (this.empty) {
        this.empty.toggleAttribute('hidden', count > 0);
      }

      // The grid paints its own hairlines, so an all-hidden grid would still draw a bar.
      if (this.results) {
        this.results.toggleAttribute('hidden', count === 0);
      }

      if (this.emptyQuery) {
        this.emptyQuery.textContent = searching ? '“' + this.query + '”' : '';
      }

      if (this.headingElement) {
        const heading = searching ? this.getAttribute('search-heading') : this.getAttribute('browse-heading');
        if (heading) this.headingElement.textContent = heading;
      }

      if (this.subheadingElement) {
        const subheading = searching ? this.getAttribute('search-subheading') : this.getAttribute('browse-subheading');
        if (subheading) this.subheadingElement.textContent = subheading;
      }

      document.dispatchEvent(new CustomEvent('help:results', { detail: { query: this.query, count: count } }));
    }
  }

  window.customElements.define('help-search', HelpSearch);
  window.customElements.define('help-topics', HelpTopics);
})();


/**
 * Help centre order lookup.
 *
 * Ships without a backend on purpose — Shopify's storefront has no native order lookup by
 * order number plus email, and the integration is being wired up separately. With no
 * `endpoint` attribute the form is disabled and explains itself, rather than presenting a
 * working-looking control that silently does nothing.
 *
 * Contract — POST JSON { order, identifier }, response either
 *   { found: true,
 *     order: { name, summary, status, carrier, tracking },
 *     steps: [ { title, detail, timestamp, done, current } ] }
 * or
 *   { found: false, message }
 */
(() => {
  class HelpTrackOrder extends HTMLElement {
    constructor() {
      super();
      this.onSubmit = this.onSubmit.bind(this);
    }

    connectedCallback() {
      this.form = this.querySelector('form');
      this.panel = this.querySelector('[data-help-track-panel]');
      this.idle = this.querySelector('[data-help-track-idle]');
      this.notice = this.querySelector('[data-help-track-notice]');
      this.error = this.querySelector('[data-help-track-error]');
      this.errorText = this.querySelector('[data-help-track-error-text]');
      this.resultTemplate = this.querySelector('[data-help-track-result]');
      this.stepTemplate = this.querySelector('[data-help-track-step]');
      this.endpoint = (this.getAttribute('endpoint') || '').trim();

      // The idle panel is the thing we restore to after a failed lookup.
      this.idleMarkup = this.panel ? Array.from(this.panel.childNodes) : [];

      if (this.endpoint === '') {
        this.disable();
        return;
      }

      // Controls ship disabled so an un-hydrated form cannot GET the customer's email into
      // the URL. Now that the element is live and will intercept submission, enable them.
      this.enable();
      this.form?.addEventListener('submit', this.onSubmit);
    }

    disconnectedCallback() {
      this.form?.removeEventListener('submit', this.onSubmit);
    }

    disable() {
      this.form?.querySelectorAll('input, button, select, textarea').forEach((control) => {
        control.disabled = true;
      });
      this.notice?.removeAttribute('hidden');
      this.setAttribute('data-unconfigured', '');
    }

    enable() {
      this.form?.querySelectorAll('input, button, select, textarea').forEach((control) => {
        control.disabled = false;
      });
      this.notice?.setAttribute('hidden', '');
    }

    // A failed lookup must not leave the previous order's timeline on screen next to
    // "we could not find that order" — the customer would read one order's status as
    // another's.
    clearResult() {
      if (this.panel && this.idleMarkup.length > 0) {
        this.panel.replaceChildren(...this.idleMarkup);
      }
    }

    get submitButton() {
      return this.form?.querySelector('[type="submit"]');
    }

    setBusy(busy) {
      const button = this.submitButton;
      if (!button) return;

      button.toggleAttribute('disabled', busy);
      button.setAttribute('aria-busy', busy ? 'true' : 'false');
    }

    showError(message) {
      if (!this.error) return;

      if (this.errorText) this.errorText.textContent = message;
      this.error.removeAttribute('hidden');
    }

    clearError() {
      this.error?.setAttribute('hidden', '');
    }

    async onSubmit(event) {
      event.preventDefault();
      this.clearError();
      this.clearResult();
      this.setBusy(true);

      const data = new FormData(this.form);

      try {
        const response = await fetch(this.endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            order: (data.get('order') || '').toString().trim(),
            identifier: (data.get('identifier') || '').toString().trim()
          })
        });

        if (!response.ok) throw new Error('Lookup failed with status ' + response.status);

        const payload = await response.json();

        if (payload && payload.found && payload.order && payload.order.name) {
          this.render(payload);
        } else {
          this.showError((payload && payload.message) || this.getAttribute('not-found-label') || '');
        }
      } catch (error) {
        console.error('[help-track-order]', error);
        this.showError(this.getAttribute('error-label') || '');
      } finally {
        this.setBusy(false);
      }
    }

    render(payload) {
      if (!this.resultTemplate || !this.panel) return;

      const fragment = this.resultTemplate.content.cloneNode(true);
      const order = payload.order || {};

      const set = (selector, value) => {
        const node = fragment.querySelector(selector);
        if (node) node.textContent = value || '';
      };

      set('[data-result-name]', order.name);
      set('[data-result-summary]', order.summary);
      set('[data-result-status]', order.status);

      const tracking = [order.carrier, order.tracking].filter(Boolean).join(' ');
      set('[data-result-tracking]', tracking);

      const list = fragment.querySelector('[data-result-steps]');

      if (list && this.stepTemplate && Array.isArray(payload.steps)) {
        payload.steps.forEach((step) => {
          const item = this.stepTemplate.content.cloneNode(true);
          const root = item.querySelector('.help-timeline__step');

          if (step.done) root?.classList.add('is-done');
          if (step.current) root?.classList.add('is-current');

          const fill = (selector, value) => {
            const node = item.querySelector(selector);
            if (node) node.textContent = value || '';
          };

          fill('[data-step-title]', step.title);
          fill('[data-step-detail]', step.detail);
          fill('[data-step-timestamp]', step.timestamp);

          list.appendChild(item);
        });
      }

      // Replace the idle placeholder rather than appending beside it. The idle markup is
      // kept in this.idleMarkup so a later failed lookup can restore it.
      this.panel.replaceChildren(fragment);
    }
  }

  window.customElements.define('help-track-order', HelpTrackOrder);
})();


/**
 * "Adding to cart" label on the product form's submit button, from the click until the cart
 * drawer has finished opening. Kept out of theme.js (vendor file) by listening to submit in
 * the capture phase, so it runs before the theme's own ProductForm handler.
 */
(() => {
  const RESTORE_FALLBACK_MS = 6000;

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!form.matches('product-form form[action*="/cart/add"]')) return;

    // Mirror the theme's own early returns, so the label only changes for a real add
    const submitter = event.submitter;
    if (submitter?.disabled || submitter?.getAttribute('aria-busy') === 'true' || !form.checkValidity()) return;

    const label = window.themeVariables.strings.addingToCartButton;
    const buttons = Array.from(form.elements).filter((element) => element.type === 'submit');
    const originals = new Map(buttons.map((button) => [button, button.innerHTML]));

    buttons.forEach((button) => button.textContent = label);

    const controller = new AbortController();
    const timeout = setTimeout(restore, RESTORE_FALLBACK_MS);

    function restore() {
      clearTimeout(timeout);
      controller.abort();

      // A variant change may have re-rendered the label in the meantime, leave that one alone
      originals.forEach((html, button) => {
        if (button.textContent === label) button.innerHTML = html;
      });
    }

    // dialog:after-show does not bubble, so it is caught in the capture phase
    document.addEventListener('dialog:after-show', (showEvent) => {
      if (showEvent.target.matches('cart-drawer')) restore();
    }, { capture: true, signal: controller.signal });

    form.addEventListener('cart:error', restore, { signal: controller.signal });
  }, true);
})();

/* ==========================================================================
   LØCI custom sections
   ========================================================================== */

/**
 * LØCI story film.
 *
 * Plays a muted, looping film while it is in view and keeps at most one film playing on the page (the one closest
 * to the viewport centre, or the one the visitor last started). Films inside an ancestor with
 * data-motion-group="parallel" play together, up to three at a time.
 *
 * Expected markup (all children are optional except the video):
 *
 *   <loci-story-film [data-control-id="external-button-id"]>
 *     <video muted playsinline loop preload="none" controls poster="..." aria-label="...">...</video>
 *     <button type="button" data-motion-start data-play-label data-pause-label data-play-text data-pause-text hidden>...</button>
 *     <button type="button" data-motion-sound aria-pressed="false" data-sound-on data-sound-off>...</button>
 *     <a href="..." data-motion-shop>...</a>
 *     <span class="sr-only" role="status" data-motion-status data-error="..."></span>
 *   </loci-story-film>
 *
 * The native video controls are only a no-JS fallback: they are removed once the custom control is wired up.
 * If the control holds an <svg>, its icon and inner <span> text are swapped; otherwise its text content is.
 * Turning sound on for one film mutes every other film on the page.
 * When the page was opened with ?sizesfor=mens|womens, [data-motion-shop] links to collections/products keep it.
 */
class LociStoryFilm extends HTMLElement {
  static instances = new Set();
  static playing = new Set();
  static preferred = null;

  static PLAY_ICON = '<path d="M1 1 11 7 1 13Z" fill="currentColor"/>';
  static PAUSE_ICON = '<path d="M2 1h3v12H2zm5 0h3v12H7z" fill="currentColor"/>';

  /**
   * Decides which films should be playing. Called whenever visibility, preference or a manual action changes.
   */
  static refresh() {
    const all = [...this.instances];
    const saveData = navigator.connection?.saveData;

    const eligible = all
      .filter((film) => film.visible && !film.manualPause && !film.blocked && (film.manualRequested || (!film.reducedMotion.matches && !saveData)))
      .sort((a, b) => a.distance - b.distance);

    const selected = document.hidden ? null : (eligible.includes(this.preferred) ? this.preferred : eligible[0]);
    const group = selected?.playbackGroup;

    let playing = selected ? [selected] : [];

    if (group) {
      playing = [selected, ...eligible.filter((film) => film !== selected && film.playbackGroup === group)].slice(0, 3);
    }

    this.playing = new Set(playing);

    all.forEach((film) => {
      if (!this.playing.has(film)) {
        film.video.pause();
      }
    });

    playing.forEach((film) => {
      if (film.video.paused && !film.starting) {
        film.playFilm();
      }
    });
  }

  connectedCallback() {
    this.video = this.querySelector('video');
    this.control = this.dataset.controlId ? document.getElementById(this.dataset.controlId) : this.querySelector('[data-motion-start]');
    this.status = this.querySelector('[data-motion-status]');

    if (!this.video || !this.control) {
      return;
    }

    this.abortController = new AbortController();
    const { signal } = this.abortController;

    this.playbackGroup = this.closest('[data-motion-group="parallel"]');
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.visible = false;
    this.distance = Infinity;
    this.manualPause = false;
    this.manualRequested = false;
    this.blocked = false;
    this.starting = false;

    this.video.muted = true;
    this.video.controls = false;
    this.control.hidden = false;

    this.control.addEventListener('click', this._onControlClick.bind(this), { signal });
    this.video.addEventListener('play', this._onPlay.bind(this), { signal });
    this.video.addEventListener('pause', this._updateControl.bind(this), { signal });
    this.reducedMotion.addEventListener('change', this._onPreferenceChange.bind(this), { signal });
    document.addEventListener('visibilitychange', () => LociStoryFilm.refresh(), { signal });

    this.querySelectorAll('[data-motion-sound]').forEach((button) => {
      button.addEventListener('click', this._onSoundClick.bind(this, button), { signal });
    });

    LociStoryFilm.instances.add(this);

    if ('IntersectionObserver' in window) {
      this.intersectionObserver = new IntersectionObserver(this._onIntersection.bind(this), { threshold: [0, 0.35, 0.6, 1] });
      this.intersectionObserver.observe(this.video);
    } else {
      this.visible = true;
    }

    this._keepSizesForParameter();
    this._updateControl();
  }

  disconnectedCallback() {
    if (!this.abortController) {
      return;
    }

    this.abortController.abort();
    this.abortController = null;
    this.intersectionObserver?.disconnect();

    LociStoryFilm.instances.delete(this);

    if (LociStoryFilm.preferred === this) {
      LociStoryFilm.preferred = null;
    }

    this.video.pause();
    LociStoryFilm.refresh();
  }

  async playFilm() {
    this.starting = true;
    this._setStatus('');

    try {
      await this.video.play();

      // Another film may have been selected (or this one scrolled away) while play() was pending
      if (!LociStoryFilm.playing.has(this) || !this.visible || document.hidden) {
        this.video.pause();
      }
    } catch {
      this.blocked = true;

      if (this.manualRequested) {
        this._setStatus(this.status?.dataset.error || '');
      }
    } finally {
      this.starting = false;
      this._updateControl();
    }
  }

  _onIntersection(entries) {
    entries.forEach((entry) => {
      this.visible = entry.isIntersecting && entry.intersectionRatio >= 0.35;
      this.distance = Math.abs(entry.boundingClientRect.top + entry.boundingClientRect.height / 2 - window.innerHeight / 2);
    });

    LociStoryFilm.refresh();
  }

  _onControlClick() {
    if (!this.video.paused) {
      this.manualPause = true;
      this.manualRequested = false;
      this.video.pause();
    } else {
      this.manualPause = false;
      this.manualRequested = true;
      this.blocked = false;
      LociStoryFilm.preferred = this;
    }

    LociStoryFilm.refresh();
  }

  _onPlay() {
    if (!LociStoryFilm.playing.has(this)) {
      this.video.pause();
    }

    this._updateControl();
  }

  _onPreferenceChange() {
    if (this.reducedMotion.matches) {
      this.manualRequested = false;
    }

    LociStoryFilm.refresh();
  }

  _onSoundClick(button) {
    const enable = this.video.muted;

    // Only one film may be heard at a time
    if (enable) {
      LociStoryFilm.instances.forEach((film) => {
        if (film !== this) {
          film.mute();
        }
      });
    }

    this.video.muted = !enable;
    this._updateSoundButton(button, enable);
  }

  mute() {
    if (!this.video) {
      return;
    }

    this.video.muted = true;
    this.querySelectorAll('[data-motion-sound]').forEach((button) => this._updateSoundButton(button, false));
  }

  _updateSoundButton(button, soundOn) {
    button.textContent = soundOn ? button.dataset.soundOff : button.dataset.soundOn;
    button.setAttribute('aria-pressed', String(soundOn));
  }

  _updateControl() {
    const playing = !this.video.paused;
    const action = playing ? this.control.dataset.pauseLabel : this.control.dataset.playLabel;
    const filmLabel = this.video.getAttribute('aria-label');
    const text = playing ? this.control.dataset.pauseText : this.control.dataset.playText;
    const icon = this.control.querySelector('svg');

    this.control.setAttribute('aria-label', filmLabel ? `${action} — ${filmLabel}` : action);

    if (icon) {
      icon.innerHTML = playing ? LociStoryFilm.PAUSE_ICON : LociStoryFilm.PLAY_ICON;
      this.control.querySelector('span').textContent = text;
    } else {
      this.control.textContent = text;
    }
  }

  _setStatus(text) {
    if (this.status) {
      this.status.textContent = text;
    }
  }

  _keepSizesForParameter() {
    const gender = new URL(window.location.href).searchParams.get('sizesfor');

    if (!['mens', 'womens'].includes(gender)) {
      return;
    }

    this.querySelectorAll('[data-motion-shop]').forEach((link) => {
      const target = new URL(link.href, window.location.origin);

      if (target.origin === window.location.origin && /\/(collections|products)\//.test(target.pathname) && !target.searchParams.has('sizesfor')) {
        target.searchParams.set('sizesfor', gender);
        link.href = target.href;
      }
    });
  }
}

if (!window.customElements.get('loci-story-film')) {
  window.customElements.define('loci-story-film', LociStoryFilm);
}

/**
 * Overall REVIEWS.io rating under the search form (snippets/loci-search-rating.liquid).
 *
 * The rating is drawn by the REVIEWS.io carousel library, which mounts by element id. The library is
 * shared with other widgets on the page (the header trust strip loads the same file), so it is only
 * injected when no other script tag for it exists yet.
 */
const REVIEWS_IO_CAROUSEL_SRC = 'https://widget.reviews.io/carousel-inline-iframeless/dist.js';

class LociSearchProofRating extends HTMLElement {
  connectedCallback() {
    this.abortController = new AbortController();

    const widget = this.widget;

    // The library keeps no handle to tear down, so a re-connected element keeps its first mount
    if (!widget || widget.hasAttribute('data-mounted')) {
      return;
    }

    if (typeof window.carouselInlineWidget === 'function') {
      this.mount();
      return;
    }

    let script = document.querySelector('script[src*="carousel-inline-iframeless/dist.js"]');

    if (!script) {
      script = document.createElement('script');
      script.src = REVIEWS_IO_CAROUSEL_SRC;
      script.async = true;
      document.head.appendChild(script);
    }

    script.addEventListener('load', this.mount.bind(this), { once: true, signal: this.abortController.signal });
  }

  disconnectedCallback() {
    this.abortController.abort();
  }

  get widget() {
    return this.querySelector('.loci-search-trust__widget');
  }

  mount() {
    const widget = this.widget;

    if (!widget?.isConnected || widget.hasAttribute('data-mounted') || typeof window.carouselInlineWidget !== 'function') {
      return;
    }

    widget.setAttribute('data-mounted', '');

    new window.carouselInlineWidget(widget.id, {
      store: 'lociwear.com',
      sku: '',
      lang: 'en',
      carousel_type: 'default',
      styles_carousel: 'CarouselWidget--sideHeader--withcards',
      options: {
        general: {
          enable_richsnippets_company: false,
          enable_richsnippets_product: false,
          review_type: 'company, product, third_party',
          min_reviews: '1',
          max_reviews: '1',
          enable_auto_scroll: false
        },
        header: { enable_overall_stars: true, rating_decimal_places: 2 },
        reviews: { enable_syndication: true, min_review_percent: 1 },
        popups: { enable_review_popups: false }
      }
    });
  }
}

if (!window.customElements.get('loci-search-proof-rating')) {
  window.customElements.define('loci-search-proof-rating', LociSearchProofRating);
}

/**
 * LØCI SERVICE PAGES
 *
 *   loci-tab-hash               wraps an <x-tabs> so a URL hash opens the matching panel. Panels opt in with
 *                               data-tab-anchor="apparel"; /pages/global-size-guide#apparel then opens on Apparel.
 *                               (x-tabs rewrites panel ids, so the hash cannot target the panel directly.)
 *   loci-delivery-destinations  turns the delivery destination links into a single-choice switcher, preselecting
 *                               the visitor's region from data-country (localization.country.iso_code).
 *
 * Both enhance markup that already works without them: x-tabs is usable on its own, and without
 * loci-delivery-destinations every destination table stays visible with the links acting as anchors.
 */
(() => {
  class LociTabHash extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      window.addEventListener('hashchange', this.selectFromHash.bind(this), { signal: this.abortController.signal });
      this.selectFromHash();
    }

    disconnectedCallback() {
      this.abortController.abort();
    }

    selectFromHash() {
      const tabs = this.querySelector('x-tabs');
      const panels = Array.from(tabs?.querySelectorAll(':scope > [slot="content"]') ?? []);
      const index = panels.findIndex((panel) => `#${panel.getAttribute('data-tab-anchor')}` === window.location.hash);

      if (index === -1) {
        return;
      }

      // Set the attribute rather than the selectedIndex property: if x-tabs has not upgraded yet, assigning the
      // property would create an own property that shadows its setter once it does.
      tabs.setAttribute('selected-index', index.toString());

      // No element carries the hash as its id, so the browser does not scroll to it on its own.
      this.scrollIntoView({ block: 'start' });
    }
  }

  if (!window.customElements.get('loci-tab-hash')) {
    window.customElements.define('loci-tab-hash', LociTabHash);
  }

  class LociDeliveryDestinations extends HTMLElement {
    static EU_COUNTRIES = ['AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE'];

    connectedCallback() {
      this.abortController = new AbortController();
      const { signal } = this.abortController;

      this.links = Array.from(this.querySelectorAll('[data-destination]'));
      this.panels = Array.from(this.querySelectorAll('[data-region]'));

      this.links.forEach((link, index) => {
        link.addEventListener('click', this.onLinkClicked.bind(this), { signal });
        link.addEventListener('keydown', this.onLinkKeydown.bind(this, index), { signal });
      });

      const hashPanel = this.panels.find((panel) => `#${panel.id}` === window.location.hash);
      this.show(hashPanel ? hashPanel.dataset.region : this.regionForCountry(this.dataset.country));
    }

    disconnectedCallback() {
      this.abortController.abort();
    }

    regionForCountry(country) {
      if (country === 'GB') return 'uk';
      if (['US', 'CA'].includes(country)) return 'north-america';
      if (LociDeliveryDestinations.EU_COUNTRIES.includes(country)) return 'eu';
      return 'world';
    }

    show(region) {
      this.links.forEach((link) => {
        const isSelected = link.dataset.destination === region;
        link.classList.toggle('is-selected', isSelected);
        link.setAttribute('aria-current', String(isSelected));
      });

      this.panels.forEach((panel) => {
        panel.hidden = panel.dataset.region !== region;
      });
    }

    onLinkClicked(event) {
      event.preventDefault();
      this.show(event.currentTarget.dataset.destination);
    }

    /* Arrow keys, Home and End move between destinations, as in a tab list. */
    onLinkKeydown(index, event) {
      const count = this.links.length;
      const nextIndex = {
        ArrowRight: (index + 1) % count,
        ArrowLeft: (index - 1 + count) % count,
        Home: 0,
        End: count - 1
      }[event.key];

      if (nextIndex === undefined) {
        return;
      }

      event.preventDefault();
      this.show(this.links[nextIndex].dataset.destination);
      this.links[nextIndex].focus();
    }
  }

  if (!window.customElements.get('loci-delivery-destinations')) {
    window.customElements.define('loci-delivery-destinations', LociDeliveryDestinations);
  }
})();

/**
 * LØCI world editorial (sections/loci-world-editorial.liquid).
 *
 * Fades block headings and story copy ([data-reveal]) in the first time they scroll into view.
 * Skipped when the visitor prefers reduced motion.
 */
class LociWorldEditorial extends HTMLElement {
  connectedCallback() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      return;
    }

    this.intersectionObserver = new IntersectionObserver(this._onIntersection.bind(this), { threshold: 0.12 });
    this.querySelectorAll('[data-reveal]').forEach((element) => this.intersectionObserver.observe(element));
  }

  disconnectedCallback() {
    this.intersectionObserver?.disconnect();
  }

  _onIntersection(entries) {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) {
        return;
      }

      entry.target.animate(
        [{ opacity: 0.65, transform: 'translateY(14px)' }, { opacity: 1, transform: 'translateY(0)' }],
        { duration: 450, easing: 'ease-out' }
      );

      this.intersectionObserver.unobserve(entry.target);
    });
  }
}

if (!window.customElements.get('loci-world-editorial')) {
  window.customElements.define('loci-world-editorial', LociWorldEditorial);
}

/**
 * LØCI material explorer (materials_story chapter).
 *
 * Switches between the bio leather and recycled panels with its [data-material] buttons. Links anywhere on the page
 * with data-choose-material="bio|recycled" (the chapter nav of the materials_intro section) select a panel too, and
 * every [data-shop-material] link is pointed at the selected material's shop rail. Opening the page with a hash
 * containing "recycled" selects the recycled panel.
 */
class LociMaterialExplorer extends HTMLElement {
  connectedCallback() {
    this.abortController = new AbortController();
    document.addEventListener('click', this._onClick.bind(this), { signal: this.abortController.signal });

    if (window.location.hash.includes('recycled')) {
      this.select('recycled');
    }
  }

  disconnectedCallback() {
    this.abortController?.abort();
  }

  select(material) {
    this.querySelectorAll('[data-material]').forEach((button) => {
      button.setAttribute('aria-pressed', String(button.dataset.material === material));
    });

    this.querySelectorAll('[data-material-panel]').forEach((panel) => {
      panel.hidden = panel.dataset.materialPanel !== material;
    });

    document.querySelectorAll('[data-shop-material]').forEach((link) => {
      link.setAttribute('href', `#le-shop-${material}`);
    });
  }

  _onClick(event) {
    const switchButton = event.target.closest('[data-material]');

    if (switchButton && this.contains(switchButton)) {
      this.select(switchButton.dataset.material);
      return;
    }

    // Chapter links keep their default jump to the explorer
    const chapterLink = event.target.closest('[data-choose-material]');

    if (chapterLink) {
      this.select(chapterLink.dataset.chooseMaterial);
    }
  }
}

if (!window.customElements.get('loci-material-explorer')) {
  window.customElements.define('loci-material-explorer', LociMaterialExplorer);
}

/**
 * LØCI detail lab (materials_story chapter).
 *
 * Each [data-detail="index"] option button shows the [data-detail-image] at the same index and hides the others.
 */
class LociDetailLab extends HTMLElement {
  connectedCallback() {
    this.abortController = new AbortController();
    this.addEventListener('click', this._onClick.bind(this), { signal: this.abortController.signal });
  }

  disconnectedCallback() {
    this.abortController?.abort();
  }

  _onClick(event) {
    const option = event.target.closest('[data-detail]');

    if (!option) {
      return;
    }

    this.querySelectorAll('[data-detail]').forEach((button) => {
      button.setAttribute('aria-pressed', String(button === option));
    });

    this.querySelectorAll('[data-detail-image]').forEach((image, index) => {
      image.hidden = String(index) !== option.dataset.detail;
    });
  }
}

if (!window.customElements.get('loci-detail-lab')) {
  window.customElements.define('loci-detail-lab', LociDetailLab);
}

/**
 * LØCI homepage editorial (sections/loci-home-editorial.liquid).
 *
 * - Reveals [data-loci-reveal] children once, as they scroll into view (skipped for reduced motion).
 * - Announces link and quick-buy clicks as a "loci:homepage:interaction" event on document, with
 *   { placement, label, destination } in its detail, for analytics listeners.
 *
 * The product rail itself is the theme's <scroll-carousel> with carousel-prev/next-button.
 */
class LociHomeEditorial extends HTMLElement {
  connectedCallback() {
    this.abortController = new AbortController();
    this.addEventListener('click', this.onClick.bind(this), { signal: this.abortController.signal });

    const revealElements = this.querySelectorAll('[data-loci-reveal]');

    if (revealElements.length === 0 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }

    this.revealObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });

    revealElements.forEach((element) => this.revealObserver.observe(element));
  }

  disconnectedCallback() {
    this.abortController.abort();
    this.revealObserver?.disconnect();
  }

  onClick(event) {
    const target = event.target.closest('a[href], button[aria-controls]');

    if (!target) {
      return;
    }

    document.dispatchEvent(new CustomEvent('loci:homepage:interaction', {
      detail: {
        placement: this.dataset.homePlacement,
        label: target.textContent.trim(),
        destination: target.getAttribute('href') || 'quick-buy'
      }
    }));
  }
}

if (!window.customElements.get('loci-home-editorial')) {
  window.customElements.define('loci-home-editorial', LociHomeEditorial);
}

/**
 * LØCI "Your own rotation" (snippets/loci-rotation.liquid).
 *
 * - Fades the shopping edits and quote ([data-rotation-reveal]) in once as they scroll into view.
 * - The optional [data-rotation-pause] toggle sets data-paused="true" on the element, which stops every animation
 *   and transition inside it (see theme.css). Its label swaps between data-pause and data-play.
 */
class LociRotation extends HTMLElement {
  connectedCallback() {
    this.abortController = new AbortController();
    this.pauseButton = this.querySelector('[data-rotation-pause]');
    this.pauseButton?.addEventListener('click', this.togglePause.bind(this), { signal: this.abortController.signal });

    const revealElements = this.querySelectorAll('[data-rotation-reveal]');

    if (revealElements.length === 0 || !('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }

    this.revealObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
          return;
        }

        if (!this.paused) {
          entry.target.classList.add('is-revealed');
        }

        observer.unobserve(entry.target);
      });
    }, { threshold: 0.12 });

    revealElements.forEach((element) => this.revealObserver.observe(element));
  }

  disconnectedCallback() {
    this.abortController.abort();
    this.revealObserver?.disconnect();
  }

  get paused() {
    return this.dataset.paused === 'true';
  }

  togglePause() {
    const paused = !this.paused;

    this.dataset.paused = String(paused);
    this.pauseButton.setAttribute('aria-pressed', String(paused));
    this.pauseButton.textContent = paused ? this.pauseButton.dataset.play : this.pauseButton.dataset.pause;
  }
}

if (!window.customElements.get('loci-rotation')) {
  window.customElements.define('loci-rotation', LociRotation);
}

/**
 * LØCI Next Chapter (sections/loci-next-chapter.liquid).
 *
 * Wraps one editorial chapter and handles its two small interactions through a single delegated click listener:
 * - [data-filter] tab buttons (journal) show only the [data-category] items whose space separated categories include
 *   the chosen one ("all" shows everything). The pressed tab is reflected by aria-pressed, which also styles it.
 * - [data-look-target] hotspots (looks) open the "shop the look" <details> they point to and scroll it into view.
 *
 * Films in the chapter are <loci-story-film> elements and play on their own.
 */
class LociNextChapter extends HTMLElement {
  connectedCallback() {
    this.abortController = new AbortController();
    this.addEventListener('click', this._onClick.bind(this), { signal: this.abortController.signal });
  }

  disconnectedCallback() {
    this.abortController?.abort();
  }

  _onClick(event) {
    const filter = event.target.closest('[data-filter]');

    if (filter) {
      this._filter(filter);
      return;
    }

    const hotspot = event.target.closest('[data-look-target]');

    if (hotspot) {
      this._openLook(hotspot);
    }
  }

  _filter(selected) {
    const category = selected.dataset.filter;

    this.querySelectorAll('[data-filter]').forEach((button) => {
      button.setAttribute('aria-pressed', String(button === selected));
    });

    this.querySelectorAll('[data-category]').forEach((item) => {
      item.hidden = category !== 'all' && !item.dataset.category.split(' ').includes(category);
    });
  }

  _openLook(hotspot) {
    const picks = document.getElementById(hotspot.dataset.lookTarget);

    if (!picks) {
      return;
    }

    picks.open = true;
    picks.scrollIntoView({
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      block: 'center'
    });
  }
}

if (!window.customElements.get('loci-next-chapter')) {
  window.customElements.define('loci-next-chapter', LociNextChapter);
}

/**
 * ---------------------------------------------------------------------------------------------------------------------
 * LØCI CATALOGUE: KEEP THE MEN'S / WOMEN'S SIZE CHOICE (sizesfor)
 * ---------------------------------------------------------------------------------------------------------------------
 *
 *   loci-sizesfor-sync  rendered by sections/loci-category-catalogue.liquid around the title and back link. Only
 *                       active when the page is the alternate view named in its `view` attribute (?view=loci-browse):
 *
 *                       - every facet:update (filters, sort, facet links) gets the current `sizesfor` param, or the
 *                         gender picked in the facets' gender-size-switcher, so the re-rendered section and the URL
 *                         written by theme.js keep it. The listener is on document in the capture phase so it runs
 *                         before theme.js's own (bubble phase) facet:update listener reads event.detail.url.
 *                       - links marked data-sizesfor-link (the back link on silhouette collections) get `sizesfor`
 *                         too. The whole section is replaced after a facet update, so this re-runs on reconnect.
 */
(() => {
  class LociSizesforSync extends HTMLElement {
    static GENDERS = ['mens', 'womens'];

    connectedCallback() {
      if (new URL(window.location.href).searchParams.get('view') !== this.getAttribute('view')) {
        return;
      }

      this.abortController = new AbortController();
      document.addEventListener('facet:update', this.onFacetUpdate.bind(this), { capture: true, signal: this.abortController.signal });
      this.updateLinks();
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    get requestedGender() {
      const gender = new URL(window.location.href).searchParams.get('sizesfor');
      return LociSizesforSync.GENDERS.includes(gender) ? gender : null;
    }

    get selectedGender() {
      // The active switcher button is the one without the outline style ("Mens" / "Womens")
      const gender = document.querySelector('facets-form gender-size-switcher .button:not(.button--outline)')?.textContent.trim().toLowerCase();
      return LociSizesforSync.GENDERS.includes(gender) ? gender : null;
    }

    updateLinks() {
      const gender = this.requestedGender;

      if (!gender) {
        return;
      }

      this.querySelectorAll('a[data-sizesfor-link]').forEach((link) => {
        const url = new URL(link.href, window.location.href);
        url.searchParams.set('sizesfor', gender);
        link.href = url.toString();
      });
    }

    onFacetUpdate(event) {
      const url = event.detail?.url;

      if (!(url instanceof URL) || url.origin !== window.location.origin || url.pathname !== window.location.pathname) {
        return;
      }

      const gender = this.requestedGender ?? this.selectedGender;

      if (gender) {
        url.searchParams.set('sizesfor', gender);
      }
    }
  }

  if (!window.customElements.get('loci-sizesfor-sync')) {
    window.customElements.define('loci-sizesfor-sync', LociSizesforSync);
  }
})();

/**
 * LØCI silhouette page (sections/loci-silhouette.liquid).
 *
 *   <loci-silhouette>
 *     <a class="loci-silhouette__gender" data-gender="mens" href="...&sizesfor=mens">Men’s</a>
 *     ...product cards, film, links...
 *   </loci-silhouette>
 *
 * When the page was opened with ?sizesfor=mens|womens, marks the matching sizing link with aria-current and carries
 * the choice through to every collection and product link on the page (product cards included), so the size picker
 * opens on the right sizing. Without the parameter the markup is left untouched.
 */
class LociSilhouette extends HTMLElement {
  connectedCallback() {
    const gender = new URL(window.location.href).searchParams.get('sizesfor');

    if (!['mens', 'womens'].includes(gender)) {
      return;
    }

    this.querySelectorAll('a[href]').forEach((link) => {
      if (link.hasAttribute('data-gender')) {
        link.setAttribute('aria-current', String(link.getAttribute('data-gender') === gender));
        return;
      }

      const target = new URL(link.getAttribute('href'), window.location.href);

      if (target.origin === window.location.origin && /\/(collections|products)\//.test(target.pathname)) {
        target.searchParams.set('sizesfor', gender);
        link.href = target.href;
      }
    });
  }
}

if (!window.customElements.get('loci-silhouette')) {
  window.customElements.define('loci-silhouette', LociSilhouette);
}
